import React, {
  useEffect,
  useState,
  ChangeEvent,
  useRef,
  HtmlHTMLAttributes,
  useMemo,
} from "react";
import {
  TextField,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Box,
  Stack,
  Modal,
  Divider,
  SvgIcon,
  Autocomplete,
  Switch,
  CircularProgress,
  TextareaAutosize,
  Tooltip,
  Collapse,
  Paper,
  FormControlLabel,
  Checkbox,
  LinearProgress,
  RadioGroup,
  Radio,
  Card,
  CardContent,
  Pagination,
  Skeleton,
  Tabs,
  Tab,
} from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Header from "../../auth/Header";
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import AddIcon from "@mui/icons-material/Add";
import "../generated_blogs.css";
import "./CreateCourse.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactComponent as CardIcon } from "../../../assets/card_ico.svg";
import { ReactComponent as TwitterIcon } from "../../../assets/traffic_monster/icon_twitter.svg";
// import { ReactComponent as XIcon } from '../../../assets/traffic_monster/x_ico.svg';
import { ReactComponent as PinterestIcon } from "../../../assets/traffic_monster/pinterest_ico.svg";
import { ReactComponent as FacebookIcon } from "../../../assets/traffic_monster/fb_ico.svg";
import { ReactComponent as LinkedinIcon } from "../../../assets/traffic_monster/linkedIn_ico.svg";
import { ReactComponent as StepArrowIcon } from "../../../assets/img/vector-5-2.svg";
import bulletChecked from "../../../assets/img/vector-8.svg"; // hollow bullet
import {
  CheckBox,
  FormatColorFill,
  Height,
  Widgets,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as VerifiedIcon } from "../../../assets/verified_ico.svg";
import { isBrowser, isMobile } from "react-device-detect";
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import {
  usePlanDetailsMutation,
  useCampaignDetailsMutation,
} from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetpagefrocampaignMutation,
  useGetCnameEntriesMutation,
  useUpdateAutoPublishFlagMutation,
  useGetverifyscriptMutation,
  useCheckverifiedMutation,
} from "../../../redux/api/promptApi";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { id } from "date-fns/locale";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { IPlanDetail } from "../../../redux/api/types";
import { useLazyGetProductQuery } from "../../../redux/api/productApi";
import { useAppSelector } from "../../../redux/store";
import { ReactComponent as Twitterico } from "../../../assets/traffic_monster/twitter__ico.svg";
import { ReactComponent as Pinterestico } from "../../../assets/traffic_monster/pinterest__ico.svg";
import { ReactComponent as Fbico } from "../../../assets/traffic_monster/fb__ico.svg";
import { ReactComponent as Linkedinico } from "../../../assets/traffic_monster/linkedin__ico.svg";
import axios from "axios";
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from "@mui/icons-material/Info";
import YouTubeIcon from "@mui/icons-material/YouTube";
import youtubeIco1 from "../../../assets/traffic_monster/youtubeIco_1.png";
import { upload } from "@testing-library/user-event/dist/upload";
import ProgressBar from "@ramonak/react-progress-bar";
import {
  setCookie,
  getCookie,
  removeCookie,
} from "../../../utils/storageUtils";
import { urPK } from "@mui/x-date-pickers";
import { useAppDispatch } from "../../../redux/store";
import { logout } from "redux/features/userSlice";
import ocesha_logo from "../../../assets/ocesha_images/ocesha_logo.png";
import { ReactComponent as BlogsIco } from "../../../assets/ocesha_images/blogs_ico.svg";
import { ReactComponent as VideoIco } from "../../../assets/ocesha_images/video_ico.svg";
import { ReactComponent as AudioIco } from "../../../assets/ocesha_images/audio_ico.svg";
import { ReactComponent as ImagesIco } from "../../../assets/ocesha_images/images_ico.svg";
import { ReactComponent as ClipIco } from "../../../assets/ocesha_images/clip_ico.svg";
import { ReactComponent as TeamIco } from "../../../assets/ocesha_images/team_ico.svg";
import { ReactComponent as EpisodeIco } from "../../../assets/ocesha_images/episode_ico.svg";
import { ReactComponent as IntegrationIco } from "../../../assets/ocesha_images/integration_ico.svg";
import { ReactComponent as UpgradeIco } from "../../../assets/ocesha_images/upgrade_ico.svg";
import { ReactComponent as BillingIco } from "../../../assets/ocesha_images/billing_ico.svg";
import { ReactComponent as SettingsIco } from "../../../assets/ocesha_images/settings_ico.svg";
import { ReactComponent as HelpIco } from "../../../assets/ocesha_images/help_ico.svg";
import { ReactComponent as LogoutIco } from "../../../assets/ocesha_images/logout_ico.svg";
import { ReactComponent as DashboardIco } from "../../../assets/ocesha_images/dashboard_ico.svg";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import uploadIcon from "../../../assets/img/upload-cloud.svg";
import checkGreen from "../../../assets/img/vector-7.svg"; // green check
import audioIcon from "../../../assets/img/icon-audio.svg";
import videoIcon from "../../../assets/img/icon-video.svg";
import docIcon from "../../../assets/img/icon-doc.svg";
import youtubeIcon from "../../../assets/img/icon-youtube.svg";
import linkIcon from "../../../assets/img/icon-link.svg";
import textIcon from "../../../assets/img/icon-text.svg";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
import { ReactComponent as EditIco } from "../../../assets/podcast_monster/edit_ico.svg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MuiTwitterIcon from "@mui/icons-material/Twitter";
import MuiFacebookIcon from "@mui/icons-material/Facebook";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ArticleIcon from "@mui/icons-material/Article";
import ImageIcon from "@mui/icons-material/Image";
import CampaignIcon from "@mui/icons-material/Campaign";
import SchoolIcon from "@mui/icons-material/School";
import PsychologyIcon from "@mui/icons-material/Psychology";
import EditNoteIcon from "@mui/icons-material/EditNote";
import QuizIcon from "@mui/icons-material/Quiz";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentIcon from "@mui/icons-material/Payment";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import TranscribeIcon from "@mui/icons-material/Transcribe";
import StarIcon from "@mui/icons-material/Star";
import MuiChip from "@mui/material/Chip";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import FolderIcon from "@mui/icons-material/Folder";
import InsightsIcon from "@mui/icons-material/Insights";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import Mydigitaltwinscreen from "./Mydigitaltwinscreen";

<StepArrowIcon
  style={{
    width: 20,
    height: 20,
    margin: "0 12px",
    opacity: 0.6,
  }}
/>;

const COURSE_OPTIONS = [
  {
    id: "ml_intro",
    title: "Introduction to Machine Learning",
    description:
      "Learn the basics of machine learning concepts and techniques.",
    audience: "IT Professional",
    difficulty: "Easy",
    price: "$150",
  },
  {
    id: "digital_marketing",
    title: "Advanced Digital Marketing Strategies",
    description: "Explore sophisticated approaches to digital marketing.",
    audience: "Marketers",
    difficulty: "Hard",
    price: "$350",
  },
  {
    id: "creative_writing",
    title: "Creative Writing Workshop",
    description: "Enhance your writing skills through guided exercises.",
    audience: "Writers",
    difficulty: "Intermediate",
    price: "$130",
  },
  {
    id: "finance",
    title: "Financial Planning Essentials",
    description:
      "Understand the key principles of personal finance management.",
    audience: "Professionals",
    difficulty: "Easy",
    price: "$100",
  },
  {
    id: "public_speaking",
    title: "Mastering Public Speaking",
    description: "Develop effective public speaking skills and confidence.",
    audience: "General",
    difficulty: "Intermediate",
    price: "$120",
  },
  {
    id: "entrepreneurship",
    title: "Entrepreneurship Fundamentals",
    description: "Discover the foundational elements of starting a business.",
    audience: "Aspiring Entrepreneurs",
    difficulty: "Easy",
    price: "$100",
  },
  {
    id: "mindfulness",
    title: "Mindfulness and Stress Reduction",
    description: "Learn techniques for mindfulness and reducing stress.",
    audience: "General",
    difficulty: "Easy",
    price: "$99",
  },
];

const COURSE_STEPS = [
  {
    number: "01",
    title: "Share your\nExpertise",
    isActive: true,
  },
  {
    number: "02",
    title: "Upload Content\nto Train",
    isActive: false,
  },
  {
    number: "03",
    title: "Choose your\nCourse Topic",
    isActive: false,
  },
  {
    number: "04",
    title: "Generate your\nCourse",
    isActive: false,
  },
];

interface ErrorResponse {
  error: {
    status: number;
    data: {
      detail: string;
    };
  };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: '#D0D5DD',
    color: "lightblack",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white", // Set background color for odd rows to white
    color: "black", // Set text color for odd rows to black
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#F2F6FA", // Set background color for even rows to gray
    color: "darkslategray",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HeaderCell = styled("div")(({ theme }) => ({
  color: "#626F86",
  fontWeight: "bold",
  fontSize: "14px",
  padding: "12px",
  textAlign: "center",
  "&:nth-child(odd)": {
    backgroundColor: "#EAECF0",
  },
  "&:nth-child(even)": {
    backgroundColor: "#F5F5F5",
  },
}));

const DataCell = styled("div")(({ theme }) => ({
  color: "#344054",
  fontSize: "14px",
  padding: "12px",
  textAlign: "center",
  "&:nth-child(odd)": {
    backgroundColor: "#EAECF0",
  },
  "&:nth-child(even)": {
    backgroundColor: "#F5F5F5",
  },
}));

const UploadedGroup = ({ icon, title, items }: any) => (
  <Box mb={2.5}>
    <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
      <Box component="img" src={icon} sx={{ width: 18 }} />
      <Typography color="white" fontWeight={600}>
        {title}
      </Typography>
    </Stack>

    {items.map((item: string, i: number) => (
      <Stack
        key={i}
        direction="row"
        spacing={1.5}
        alignItems="center"
        ml={4}
        mb={0.5}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "#22C55E",
          }}
        />
        <Typography color="#9CA3AF" fontSize="14px">
          {item}
        </Typography>
      </Stack>
    ))}
  </Box>
);

/* const courses = [
    {
        id: 1,
        title: "AI for Leaders",
        author: "Jessica Park",
        desc: "Learn how to leverage AI in your work.",
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
        price: 199,
        oldPrice: 299,
        rating: 4.2,
        ratingsCount: 155,
    },
    {
        id: 2,
        title: "Podcast Growth Blueprint",
        author: "Dan Moore",
        desc: "Step-by-step guide to scaling a show.",
        image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
        price: 99,
        oldPrice: 199,
        rating: 4.3,
        ratingsCount: 1155,
    },
    {
        id: 3,
        title: "Mindful Parenting Essentials",
        author: "Rachli Kim",
        desc: "Practice happy and conscious parenting.",
        image: "https://images.unsplash.com/photo-1516627145497-ae6968895b74",
        price: 149,
        oldPrice: 299,
        rating: 4.3,
        ratingsCount: 1155,
    },
]; */

const   Visitcourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { FromEdit } = location.state || {};
  const { campIdFrEdit } = location.state || {};
  const { subscriptionFromCampList } = location.state || {};
  const { subscriptionTH } = location.state || {};
  const { mode } = location.state || {};

  //console.log(subscriptionTH);
  //console.log(mode);
  const [sourceUrl, setSourceUrl] = useState<string>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("UrlfromLanding")
      ? localStorage.getItem("UrlfromLanding") || ""
      : "",
  );
  const [blogcount, setBlogCount] = useState<any>(1);
  const [sourceYoutubeUrl, setSourceYoutubeUrl] = useState<any>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("YoutubeUrlfromLanding")
      ? localStorage.getItem("YoutubeUrlfromLanding") || ""
      : "",
  );
  const [sourceText, setSourceText] = useState<string>("");
  const [videoTag, setVideoTag] = useState<string>(sourceYoutubeUrl || "");
  const [twitterUrl, settwitterUrl] = useState<string>("");
  const [fbUrl, setfbUrl] = useState<string>("");
  const [pintrestUrl, setPintrestUrl] = useState<string>("");
  const [linkedinUrl, setLinkedinUrl] = useState<string>("");
  const [ctaLabel, setCtaLabel] = useState<string>("");
  const [ctaLink, setCtaLink] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);
  const [userInput, setUserInput] = useState(
    "My name is Sarah Jackson and i am a professional speech therapy trainer...",
  );
  const [introInput, setIntroInput] = useState(
    "Do you have any questions ask me...",
  );
  const [expertise, setExpertise] = useState(
    "My name is Sarah Jackson and I am a professional speech therapy trainer...",
  );
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<BlobPart[]>([]);

  const [isListening, setIsListening] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const recognitionRef = useRef<any>(null);

  const [campaignName, setCampaignName] = useState<string>("");
  const [urlPrefix, setUrlPrefix] = useState<string>(
    localStorage.getItem("ErrorAlert") === "true" &&
      localStorage.getItem("YoutubeUrlfromLanding")
      ? "youtubeid"
      : localStorage.getItem("ErrorAlert") === "true" &&
        localStorage.getItem("UrlfromLanding")
        ? "https://"
        : "https://",
  );
  const [expanded, setExpanded] = useState(true);
  const [expanded1, setExpanded1] = useState(true);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const [expanded7, setExpanded7] = useState(false);
  const [expanded8, setExpanded8] = useState(false);
  const [expanded9, setExpanded9] = useState(false);
  const [expanded10, setExpanded10] = useState(false);
  const [expanded11, setExpanded11] = useState(false);
  const [expanded12, setExpanded12] = useState(false);
  const [expanded14, setExpanded14] = useState(false);
  const [expanded15, setExpanded15] = useState(false);
  const [expanded13, setExpanded13] = useState(false);
  const [planDetails, setPlanDetails] = useState<any>();
  const [campDetails, setCampDetails] = useState<any>();
  const [defaultPlanDetails, setDefaultPlanDetails] = useState<any>();
  const [campaignId, setCampaignId] = useState<any>();
  const [userDetails, setUserDetails] = useState<any>();
  const [openpaymentInstructModal, setOpenPaymentInstructModal] =
    useState<boolean>(false);
  const [paymentOption, setPaymentOption] = useState<any>();
  const [paymentOptYearlyCal, setPaymentOptYearlyCal] = useState<any>();
  const paymentSectionRef = useRef<HTMLDivElement>(null);
  const getcnameEntriesRef = useRef<HTMLDivElement>(null);
  const getVerifyScript = useRef<HTMLDivElement>(null);
  const [autoPublish, setAutopublish] = useState<any>(false);
  const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
  const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
  const [competitorSearch, setCompetitorSearch] = useState<any>(false);
  const [limitPublish, setLimitPublish] = useState<any>(true);
  const [socialMediaUrlPublish, setSocialMediaUrlPublish] = useState<any>();
  const [addtags, setAddTags] = useState<any>(true);
  const [externalLinks, setExternalLinks] = useState<any>(true);
  const [toc, setToc] = useState<any>(true);
  const [capturleads, setCapturLeads] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [newsletter, setNewsLetter] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [twitternbutton, setTwitternButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [fbbutton, setFbButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [pintrestbutton, setPintrestButton] = useState<any>(true);
  const [linkedinbutton, setLinkedinButton] = useState<any>(
    !!planDetails?.embed_contact_form_newsletters_social_media_share,
  );
  const [video, setVideo] = useState<any>(!!planDetails?.embed_youtube_video);
  const [useOwnDomain, setUseOwnDomain] = useState<any>(false);
  const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
  const [openGetPagesuccessModal, setOpenGetPageSuccessModal] =
    useState<boolean>(false);
  const [confirmCancelSubscription, setConfirmCancelSubscription] =
    useState<boolean>(false);
  const [cnameRecords, setCnameRecords] = useState<any>();
  const [cnameDomainName, setCnameDomainName] = useState<any>();
  const [isLoadingCnameRec, setIsLoadingCnameRec] = useState<boolean>(false);
  const getpageRunref = useRef(false);
  const [script, setScript] = useState<any>();
  const [verifyCheck, setVerifyCheck] = useState<any>();
  const [period, getPeriodState] = useState("monthly");
  const [createCampaignMutation] = useCreateCampaignMutation();
  const user_email =
    localStorage.getItem("user_email") || getCookie("user_email") || "";
  const [isUpdateLoader, setIsUpdateLoader] = useState<boolean>(false);
  const [selectedSubscriptionLevel, setSelectedSubscriptionLevel] =
    useState<string>("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [selectedCourses, setSelectedCourses] = useState<string[]>([]);
  const [courses, setCourses] = useState<any>();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingcourses, setLoadingCourses] = useState<boolean>();
  const [enrolledCourseIds, setEnrolledCourseIds] = useState<string[]>([]);

  const limit = 12;

  const toggleCourse = (id: string) => {
    setSelectedCourses((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };

  const [getProduct, getState] = useState<any>(); //useLazyGetProductQuery();
  const [plans, setPlans] = useState<IPlanDetail[]>([
    {
      user: 1,
      plan_name: "",
      total_wishes: 0,
      price: "",
      period: "",
      product_id: "",
      price_id: "",
      subscription_level: "",
      feature: [],
      contracts: 0,
      type: "",
      button_text: "",
      save: "",
    },
  ]);
  const [productModule, setProductModule] = useState("");
  const genieSelector = useAppSelector((state) => state.genieState);

  const [createCheckoutSession, checkoutState] =
    useLazyCreateCheckoutSessionQuery();
  const [getUserDetailsMutation] = useGetUserDetailsMutation();

  // console.log('is this from edit=>', FromEdit);
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const [getuserCampDetails] = useCampaignDetailsMutation();
  const [getPageforCampaign] = useGetpagefrocampaignMutation();
  const [getCnameEntriesMutation] = useGetCnameEntriesMutation();
  const [getverifyscript] = useGetverifyscriptMutation();
  const [getcheckverified] = useCheckverifiedMutation();
  const [updateAutoPublishCheckMutation] = useUpdateAutoPublishFlagMutation();

  const [userImage, setUserImage] = useState<File | null>(null);
  const [userImageUrl, setUserImageUrl] = useState("");
  const [socialUrl, setSocialUrl] = useState("");
  const [name, setName] = useState("");
  const [useAsDefault, setUseAsDefault] = useState(false);
  const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
  const [campaignListMutation] = useCampaignListMutation();
  const [campaignDatas, setCampaignDatas] = useState<any>();
  const [couponCode, setCouponCode] = useState<string>("");
  const [successCancelSubscription, setSuccessCancelSubscription] =
    useState(false);
  const [podcastoryoutubeurl, setPodcastOrYoutubeUrl] = useState("");
  const [selectedSection, setSelectedSection] = useState("websiteSection");
  const [uploadVideo, setUploadVideo] = useState("");
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [uploadedvideopath, setUploadedvideopath] = useState("");
  const [getPageError, setGetPageError] = useState(false);
  const [loaderProgress, setLoaderProgress] = useState<any>(4);
  const [userBusinessText, setUserBusinessText] = useState("");
  const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
  const [deleteCourseModal, setDeleteCourseModal] = useState<boolean>(false);
  const [deleteCourseId, setDeleteCourseId] = useState<string | null>(null);

  // ─── Publish icon states (blogs_section pattern) ──────────────────────────
  interface BlogSuggestion {
    type: string; title: string; hook: string; source_reference: string;
    platform: string | string[]; estimated_engagement: string;
    content_angle: string; key_points: string[];
    image_url: string; image_url_small: string;
  }
  interface LoadingStates { [key: string]: boolean; }
  const [isPublishLoading, setIsPublishLoading] = useState<LoadingStates>({});
  const [customizeModal, setCustomizeModal] = useState<boolean>(false);
  const [currentSuggestion, setCurrentSuggestion] = useState<BlogSuggestion | null>(null);
  const [currentCourseForPublish, setCurrentCourseForPublish] = useState<any>(null);
  const [customizeTitle, setCustomizeTitle] = useState<string>('');
  const [customizeHook, setCustomizeHook] = useState<string>('');
  const [customizePlatform, setCustomizePlatform] = useState<string>('twitter');
  const [customizeContentAngle, setCustomizeContentAngle] = useState<string>('');
  const [customizeKeyPoints, setCustomizeKeyPoints] = useState<string>('');
  const [isGeneratingFromSuggestion, setIsGeneratingFromSuggestion] = useState<boolean>(false);

  const [loadingText, setLoadingText] = useState<any>(
    <Typography fontSize="18px">
      <b>Analyzing Your Content</b>
      <br />
      We’re using AI Agents to read through your content, analyze your content,
      and will suggest some ideas that we can write about
    </Typography>,
  );
  const [intervaltime, setIntervalTime] = useState(4000);
  const handleCouponTextChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCouponCode(event.target.value);
  };
  const [helpervideosrc, setHelperVideoSrc] = useState<any>();
  const [helperPopup, setHelperPopup] = useState<boolean>(false);
  const [isScrapcheckloading, setIsScrapcheckloading] =
    useState<boolean>(false);
  const [activeItem, setActiveItem] = useState(
    localStorage.getItem("activeItem") || "dashboard",
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [topics, setTopics] = useState<any>();
  const [topicsList, setTopicsList] = useState<boolean>(false);
  const [selectedTopic, setSelectedTopic] = useState<any>();
  const [keywords, setKeywords] = useState<any>();
  const [keywordsList, setKeywordsList] = useState<boolean>(false);
  const [selectedKeyword, setSelectedKeyword] = useState<any>();
  const [isKeywordLoader, setIsKeywordLoader] = useState<boolean>(false);
  const [activeLoadingCard, setActiveLoadingCard] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [isContentOpen, setIsContentOpen] = useState(false);
  //console.log("localStorage......");
  //console.log(localStorage)

  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
  const mentorid = localStorage.getItem("mentor_id") || "";

const fetchData = async () => {
  try {
    const response = await getUserDetailsMutation({
      email: mentorid,
      filter: "",
      start_date: "",
      end_date: "",
    });

    if ("data" in response) {
      const userData = response.data.data;

      setUserDetails(userData);

      localStorage.setItem("student_id", userData._id);
      localStorage.setItem("mentor_email", userData.email);
      // changed userid to mentorid
      localStorage.setItem("mentor_id", userData._id);

      console.log("userDet =>", userData);
    }
  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  fetchData();
}, []);
  const mentor_email = localStorage.getItem("mentor_email") || "";

  const getCourselisting = async (currentPage = page) => {
    setLoadingCourses(true);
    try {
      const res = await axios.get(
        `${apiUrl}/api/prompts/courses/by-user?user_email=${mentor_email}&page=${currentPage}&limit=${limit}`,
      );
      console.log("course listing response=>", res);
      setCourses(res?.data?.courses);

      setTotalPages(res?.data?.pagination?.total_pages);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };
  const handleDeleteCourse = async (courseId: string) => {
    setDeleteCourseModal(false);
    setDeleteCourseId(null);
    try {
      const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.post(`${apiUrl}/api/prompts/delete_course_content`, {
        course_id: courseId,
        content_type: "audio",
        index: 0,
      });
      const isSuccess =
        response.status === 200 ||
        response.status === 204 ||
        response.data?.status === 'success' ||
        response.data?.success === true ||
        (typeof response.data === 'string' && response.data.toLowerCase().includes('success'));
      if (isSuccess) {
        toast.success('Course deleted successfully');
        setCourses((prev: any) => Array.isArray(prev) ? prev.filter((c: any) => c._id !== courseId) : prev);
      } else {
        toast.error('Failed to delete course');
      }
    } catch (err: any) {
      console.error(err);
      toast.error('Failed to delete course');
    }
  };

  const renderStars = (rating: number) => {
    const safeRating = Math.round(rating || 0);

    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon
        key={index}
        style={{
          color: index < safeRating ? "#f5b50a" : "#ccc",
          fontSize: "18px",
        }}
      />
    ));
  };

  const getAllCourselisting = async (currentPage = page) => {
    setLoadingCourses(true);
    try {
      const res = await axios.get(
        `${apiUrl}/api/prompts/courses/all?search=${""}&page=${currentPage}&limit=${limit}`,
      );
      console.log("all course listing response=>", res);
      setCourses(res?.data?.courses);

      setTotalPages(res?.data?.pagination?.total_pages);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  const getenrolledCourselisting = async (currentPage = page) => {
    setLoadingCourses(true);
    try {
      const res = await axios.get(
        `${apiUrl}/api/student/courses/enrolled?user_email=${user_email}&page=${currentPage}&limit=${limit}`,
      );
      console.log("all course listing response=>", res);
      // setCourses(res?.data?.courses);
      const enrolledCourses = res?.data?.courses || [];

      setCourses(enrolledCourses);

      setEnrolledCourseIds(enrolledCourses.map((c: any) => c._id));

      setTotalPages(res?.data?.pagination?.total_pages);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    if (userDetails?.role === "student" && tabValue === 0) {
      getAllCourselisting(page);
    } else if (userDetails?.role === "student" && tabValue === 1) {
      getenrolledCourselisting(page);
    } else {
      getCourselisting(page);
    }
  }, [page, userDetails?.role, tabValue]);

  const handleFilesUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    setUploadedFiles((prev: File[]) => [...prev, ...Array.from(files)]);

    // allow selecting same file again
    event.target.value = "";
  };

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "audio/webm",
    });

    audioChunksRef.current = [];

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = sendAudioToBackend;

    mediaRecorder.start();
    mediaRecorderRef.current = mediaRecorder;
    setIsRecording(true);
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  const sendAudioToBackend = async () => {
    const audioBlob = new Blob(audioChunksRef.current, {
      type: "audio/webm",
    });

    const formData = new FormData();
    formData.append("audio", audioBlob, "speech.webm");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE}/speech_to_text`,
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();

      // assuming FastAPI returns: { text: "..." }
      setExpertise((prev) => `${prev} ${data.text}`.trim());
    } catch (err) {
      console.error("Speech upload failed", err);
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const handleExpandClick1 = () => {
    setExpanded1(!expanded1);
  };
  const handleExpandClick2 = () => {
    if (planDetails?.plan_name === "ENTERPRISE") {
      setExpanded2(!expanded2);
    } else {
      setUpgradeModal(true);
    }
  };
  const handleExpandClick3 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded3(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded3(false);
                return false;
            } */
    if (planDetails?.white_label_options === true) {
      setExpanded3(!expanded3);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick4 = () => {
    setExpanded4(!expanded4);
  };

  const handleExpandClick5 = () => {
    setExpanded5(!expanded5);
  };

  const handleExpandClick6 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded6(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded6(false);
                return false;
            } */
    setExpanded6(!expanded6);
  };

  const handleExpandClick7 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {

            setExpanded7(false);
            return false;
        }
        if (planDetails)

            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded7(false);
                return false;
            } */

    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded7(!expanded7);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick8 = () => {
    /*  if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
             || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
             || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
             || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
             setExpanded8(false);
             return false;
         }
         if (planDetails)
             if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                 setExpanded8(false);
                 return false;
             } */
    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded8(!expanded8);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick9 = () => {
    /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded9(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded9(false);
                return false;
            } */
    if (
      planDetails?.embed_contact_form_newsletters_social_media_share === true
    ) {
      setExpanded9(!expanded9);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick10 = () => {
    setExpanded10(!expanded10);
  };

  const handleExpandClick11 = () => {
    if (planDetails?.embed_youtube_video === true) {
      setExpanded11(!expanded11);
    } else {
      setUpgradeModal(true);
    }
  };

  const handleExpandClick12 = () => {
    setExpanded12(!expanded12);
  };

  const handleExpandClick14 = () => {
    setExpanded14(!expanded14);
  };

  const handleExpandClick15 = () => {
    setExpanded15(!expanded15);
  };

  useEffect(() => {
    if (!("webkitSpeechRecognition" in window)) {
      console.warn("Speech recognition not supported");
      return;
    }

    const recognition = new (window as any).webkitSpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-US";

    recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      setExpertise((prev) => `${prev} ${transcript}`.trim());
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = () => {
      setIsListening(false);
    };

    recognitionRef.current = recognition;
  }, []);

  useEffect(() => {
    const campaignRes = async () => {
      try {
        const response = await campaignListMutation({
          email: mentor_email || getCookie("mentor_email") || "",
        });
        if ("data" in response) {
          setCampaignDatas(response.data);
          console.log("campaign list response=>", response.data);
        } else {
          console.error("Error fetching campaign List:", response.error);
        }
      } catch (error) {
        console.log("Error fetching campaign List:", error);
      }
    };
    campaignRes();
  }, [mentor_email]);

  useEffect(() => {
    localStorage.removeItem("publishingCampId");
  }, []);

  const handleMicClick = async () => {
    if (!recognitionRef.current) return;

    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
      return;
    }

    try {
      // THIS LINE IS REQUIRED
      await navigator.mediaDevices.getUserMedia({ audio: true });

      recognitionRef.current.start();
      setIsListening(true);
    } catch (err) {
      console.error("Mic access error", err);
    }
  };

  // ─── Helper: populate modal state ─────────────────────────────────────────
  const populateSuggestionIntoModal = (suggestion: BlogSuggestion) => {
    setCurrentSuggestion(suggestion);
    setCustomizeTitle(suggestion.title || '');
    setCustomizeHook(suggestion.hook || '');
    setCustomizePlatform(
      Array.isArray(suggestion.platform)
        ? (suggestion.platform as any)[0] || 'twitter'
        : suggestion.platform || 'twitter'
    );
    setCustomizeContentAngle(suggestion.content_angle || '');
    setCustomizeKeyPoints(
      Array.isArray(suggestion.key_points) ? suggestion.key_points.join('\n') : '',
    );
  };

  // ─── Helper: build a fallback suggestion from the course ──────────────────
  const buildFallbackSuggestion = (course: any): BlogSuggestion => {
    const desc = course.description || course.title || '';
    return {
      type: 'Social Post',
      title: course.title || '',
      hook: desc.substring(0, 300),
      source_reference: course.title || '',
      platform: 'twitter',
      estimated_engagement: 'high',
      content_angle: 'informative',
      key_points: [desc.substring(0, 150), desc.substring(150, 300), desc.substring(300, 450)],
      image_url: course.thumbnail_url || course.image_url || '',
      image_url_small: course.thumbnail_url || '',
    };
  };

  // ─── handlePublishIconClick (course) ────────────────────────────
  const handlePublishIconClick = async (course: any) => {
    const courseId = course._id;
    setIsPublishLoading((prev) => ({ ...prev, [courseId]: true }));
    setCurrentCourseForPublish(course);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const emailToUse = user_email || getCookie('user_email') || '';
      // Trigger suggestion generation
      const triggerRes = await axios.post(
        `${apiUrl}/api/prompts/process_blog_suggestions_trigger`,
        { blog_id: courseId, user_email: emailToUse },
        { headers: { 'Content-Type': 'application/json' } },
      );
      const taskId = triggerRes.data?.task_id || triggerRes.data?.id || triggerRes.data;
      if (!taskId) {
        // No task id - navigate directly with course data
        navigate('/ocesha/publish-schedule-clip', {
          state: {
            postContent: course.description || course.title || '',
            postId: courseId || '',
            clipTitle: course.title || '',
            clipThumbnail: course.thumbnail_url || course.image_path_small || '',
            platform: 'twitter',
            blogId: courseId || '',
          },
        });
        return;
      }
      const pollTaskStatus = (): Promise<any> =>
        new Promise((resolve, reject) => {
          const interval = setInterval(async () => {
            try {
              const statusRes = await axios.get(`${apiUrl}/api/prompts/task_status`, { params: { task_id: taskId }, headers: { 'Content-Type': 'application/json' } });
              const statusData = statusRes.data;
              if (statusData?.state === 'done') { clearInterval(interval); resolve(statusData); }
            } catch (err) { clearInterval(interval); reject(err); }
          }, 5000);
        });
      const doneData = await pollTaskStatus();
      let suggestions: any[] = [];
      const resultData = doneData?.result?.data;
      if (resultData?.blog_suggestions && Array.isArray(resultData.blog_suggestions)) {
        suggestions = resultData.blog_suggestions;
      } else if (Array.isArray(resultData)) {
        suggestions = resultData;
      } else if (doneData?.result && Array.isArray(doneData.result)) {
        suggestions = doneData.result;
      }
      const postContent = suggestions.length > 0
        ? (suggestions[0]?.hook || suggestions[0]?.title || course.description || course.title || '')
        : (course.description || course.title || '');
      // Navigate directly to PublishScheduleClip with dynamic course data
      navigate('/ocesha/publish-schedule-clip', {
        state: {
          postContent,
          postId: courseId || '',
          clipTitle: suggestions[0]?.title || course.title || '',
          clipThumbnail: course.thumbnail_url || course.image_path_small || '',
          platform: suggestions[0]?.platform || 'twitter',
          blogId: courseId || '',
        },
      });
    } catch (error) {
      console.error('Error in handlePublishIconClick:', error);
      toast.error('Something went wrong. Please try again.');
      // Fallback navigate with course data
      navigate('/ocesha/publish-schedule-clip', {
        state: {
          postContent: course.description || course.title || '',
          postId: courseId || '',
          clipTitle: course.title || '',
          clipThumbnail: course.thumbnail_url || course.image_path_small || '',
          platform: 'twitter',
          blogId: courseId || '',
        },
      });
    } finally {
      setIsPublishLoading((prev) => ({ ...prev, [courseId]: false }));
    }
  };

  // ─── handleGenerateFromCustomize (course) ─────────────────────────────────
  const handleGenerateFromCustomize = async () => {
    if (!currentCourseForPublish) return;
    setIsGeneratingFromSuggestion(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const emailToUse = mentor_email || getCookie('mentor_email') || '';
      const keyPointsArray = customizeKeyPoints.split('\n').filter((kp) => kp.trim() !== '');
      const payload = {
        suggestion: {
          type: currentSuggestion?.type || 'Social Post',
          title: customizeTitle,
          hook: customizeHook,
          source_reference: currentSuggestion?.source_reference || customizeTitle,
          platform: customizePlatform,
          estimated_engagement: currentSuggestion?.estimated_engagement || 'high',
          content_angle: customizeContentAngle,
          key_points: keyPointsArray.length > 0 ? keyPointsArray : [customizeHook.substring(0, 150)],
          image_url: currentCourseForPublish.thumbnail_url || '',
          image_url_small: currentCourseForPublish.thumbnail_url || '',
        },
      };
      const response = await axios.post(
        `${apiUrl}/api/prompts/api/posts/generate?user_email=${encodeURIComponent(emailToUse)}`,
        payload,
        { headers: { 'Content-Type': 'application/json', accept: 'application/json' } },
      );
      if (response.data.status === 'success') {
        const post = response.data.posts[0];
        try {
          const publishRes = await axios.post(
            `${apiUrl}/api/prompts/api/posts/${post.id}/activate?user_email=${encodeURIComponent(emailToUse)}`,
            {},
            { headers: { accept: 'application/json' } },
          );
          if (publishRes.data.status === 'success') { toast.success(`Post generated & queued for ${customizePlatform}`); }
          else { toast.error('Generated but failed to publish'); }
        } catch { toast.success('Post generated successfully'); }
        setCustomizeModal(false);
        navigate('/ocesha/publish-schedule-clip', {
          state: {
            postContent: post?.content || post,
            postId: post?.id || '',
            clipTitle: customizeTitle || currentCourseForPublish?.title || '',
            clipThumbnail: currentCourseForPublish?.thumbnail_url || '',
            platform: customizePlatform,
            blogId: currentCourseForPublish?._id || '',
          },
        });
      } else { toast.error('Failed to generate post'); }
    } catch (error) {
      console.error('Generate error:', error);
      toast.error('Something went wrong generating the post');
    } finally {
      setIsGeneratingFromSuggestion(false);
    }
  };

  const handleEditClick = () => {
    textareaRef.current?.focus();
  };

  const validateCampaignName = () => {
    /* if(campaignName === ''){
            toast.error('Please fill your Campaign Name!');
            return false;
        } */

    const isDuplicate = campaignDatas.some(
      (campaign: any) => campaign.campaign_name === campaignName,
    );
    if (isDuplicate) {
      toast.error("Duplicate campaign Name. Please choose a different name!");
      return false;
    }
    return true;
  };

  const youtubeMatch = videoTag?.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  //console.log('plan details =>', plans);
  const handleCreateCampaignClickold = async () => {
    if (
      FromEdit === "startEditing" ||
      localStorage.getItem("ChangepayMode") === "true"
    ) {
      if (video && !videoTag) {
        toast.error("Please enter YouTube video URL on video section");
      } else if (video && !youtubeMatch) {
        toast.error("Please enter only YouTube video URL");
      } else {
        autoPublishCheck(campIdFrEdit);
        handleUpdateSetting(campIdFrEdit);
        localStorage.removeItem("ChangepayMode");
        localStorage.removeItem("IdChangingMode");
      }
      // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
      // if(planDetails?.owndomain === '1'){

      // }
    } else {
      // debugger;
      // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
      if (
        campaignName ===
        "" /* || sourceUrl === '' || !paymentOption || (!limitPublish && !autoPublish) */
      ) {
        // toast.error(`Please fill all the * required fields!`);
        toast.error("Please fill your Campaign Name!");
      } /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ else if (
        (urlPrefix === "text" && sourceText === "") ||
        (urlPrefix !== "text" && sourceUrl === "")
      ) {
        toast.error("Please fill your Source Page URL/TEXT");
      } else if (video && !videoTag) {
        /* else if (!paymentOption) {
                toast.error('Please choose the payment option!');
                return;
            }  */ /* else if (!autoPublish) {
            toast.error('Please fill the autopublish blog!');
        } */
        toast.error("Please enter YouTube video URL on video section");
      } else if (video && !youtubeMatch) {
        toast.error("Please enter only YouTube video URL");
      } else {
        /* else if (!name) {
                toast.error('Please fill the required field on author section!');
            } */
        try {
          var tmpurl =
            urlPrefix === "https://"
              ? (document.getElementById("sourceurl") as HTMLInputElement)
                ?.value
              : "";
          if (tmpurl.indexOf("http") < 0)
            tmpurl = urlPrefix === "https://" ? "https://" + tmpurl : "";

          const finalurl = tmpurl;
          const youtubeMatch = finalurl?.match(
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
          );

          setIsLoadingGetPage(true);
          const videoid = youtubeMatch ? youtubeMatch[1] : "";

          const response = await createCampaignMutation({
            campaign_name: campaignName,
            url: finalurl ? encodeURIComponent(finalurl) : "",
            email: mentor_email || getCookie("mentor_email") || "",
            sourcemode: urlPrefix === "text" ? "text" : "url",
            videoid: videoid ? videoid : "",
            product_desc: sourceText ? encodeURIComponent(sourceText) : "",
          });
          console.log("response==" + response);

          if ("data" in response) {
            console.log("created campaign result=>", response.data); //getting campaign id here
            if (response.data.status === "success") {
              setCampaignId(response.data.campaign_id);
              autoPublishCheck(response.data.campaign_id);
              handleUpdateSetting(response.data.campaign_id);
              handleVerifyCheckClick(response.data.campaign_id);
              toast.success(response.data.msg);
              setIsLoadingGetPage(false);
              localStorage.setItem("fromNewcampaign", "true");
              handleCheckout(response.data.campaign_id);
              // setOpenPaymentInstructModal(true);
            } else if (response.data.status === "failed") {
              setIsLoadingGetPage(false);
              toast.error(response.data.msg);
            }
          } else {
            const errorMessage = (response?.error as any)?.data?.detail as
              | string
              | undefined;

            toast.error(errorMessage);
            setIsLoadingGetPage(false);
            //window.location.reload();
          }
        } catch (error) {
          setIsLoadingGetPage(false);
          console.log("Error creating campaign:", error);
        }
      }
    }
  };

  const handleTextChange = (event: any) => {
    let inputText = event.target.value;
    setUserBusinessText(inputText);
  };

  useEffect(() => {
    let intervalId: any;
    if (isloadingGetPage && loaderProgress < 100) {
      intervalId = setInterval(() => {
        setLoaderProgress((prevProgress: any) => {
          const newProgress = prevProgress + 2;
          return newProgress >= 98 ? 98 : newProgress;
        });
      }, intervaltime);
    }

    return () => clearInterval(intervalId);
  }, [isloadingGetPage, loaderProgress]);

  /*** code for celery starts */
  interface TaskStatusResponse {
    state: "pending" | "done" | "error";
    result?: any;
    message?: string;
  }

  interface ScrapPageResponse {
    task_id: string;
  }

  // Utility to sleep for some ms
  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const waitForTaskResult = async (
    taskId: string,
    apiUrl: string,
  ): Promise<any> => {
    const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;

    while (true) {
      const { data } = await axios.get<TaskStatusResponse>(statusUrl);

      if (data.state === "done") {
        return data.result;
      } else if (data.state === "error") {
        throw new Error(data.message || "Task failed");
      }

      await sleep(2000); // poll every 2 seconds
    }
  };

  /*** code for celery ends */

  const handlescrappage = async (url: string) => {
    setIsLoadingGetPage(true);
    setLoaderProgress(4);
    // setIsScrapcheckloading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      // const response = await axios.get(
      //     `${apiUrl}/api/prompts/scrap_page?url=${url}`,
      // );

      // Step 1: start the task
      const { data } = await axios.get<ScrapPageResponse>(
        `${apiUrl}/api/prompts/scrap_page?url=${encodeURIComponent(url)}`,
      );
      const taskId = data.task_id;

      // Step 2: poll until done
      const response = await waitForTaskResult(taskId, apiUrl);

      console.log("scrap_page response=>", response);
      if (response.result === "failed") {
        setIsLoadingGetPage(false);
        toast.error(response.data);
      } else {
        handleCreateCampaignClick();
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setIsScrapcheckloading(false);
      setLoaderProgress(15);
    }
  };

  useEffect(() => {
    console.log(campaignId);
  }, [campaignId]);

  const handleCreateCourseStep2 = async () => {
    //Save and then move to next screen
    navigate("/codegenie/new-course-3");
  };

  const handleCreateCourseStepPrevious = async () => {
    //Save and then move to next screen
    navigate("/codegenie/new-course-2-1");
  };

  const handleCreateCampaignClick = async () => {
    console.log("fromedit=>", FromEdit);
    console.log("campId=>", campIdFrEdit);
    if (
      FromEdit === "startEditing" ||
      localStorage.getItem("ChangepayMode") === "true"
    ) {
      /*  if (video && !videoTag) {
                 toast.error('Please enter YouTube video URL on video section');
             } else if (video && !youtubeMatch) {
                 toast.error('Please enter only YouTube video URL');
 
             } else { */
      autoPublishCheck(campIdFrEdit);
      handleUpdateSetting(campIdFrEdit);
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      // }
      // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
      // if(planDetails?.owndomain === '1'){

      // }
    } else {
      // debugger;
      // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
      /*  if (campaignName === '') {
                toast.error('Please fill your Campaign Name!');
            }  */ /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ /*  else */ if (
        (urlPrefix === "text" && userBusinessText === "") ||
        (urlPrefix === "https://" && sourceUrl === "") ||
        (urlPrefix === "youtubeid" && sourceYoutubeUrl === "") ||
        (urlPrefix === "upload" && !uploadedvideopath)
      ) {
        toast.error("Please fill any one of the source type!");
      } else if (
        (sourceUrl || userBusinessText) &&
        blogcount > planDetails?.blog_count_balance
      ) {
        setUpgradeModal(true);
        // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
      } else if (
        (sourceYoutubeUrl || uploadedvideopath) &&
        blogcount > planDetails?.podcast_count_balance
      ) {
        setUpgradeModal(true);
        // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
      } else {
        try {
          var tmpurl =
            urlPrefix === "youtubeid"
              ? (
                document.getElementById(
                  "sourceyoutubeurl",
                ) as HTMLInputElement
              )?.value
              : "";
          if (tmpurl.indexOf("http") < 0)
            tmpurl = urlPrefix === "youtubeid" ? "https://" + tmpurl : "";

          const finalurl = tmpurl;
          /* const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    ); */
          const youtubeMatch = finalurl?.match(
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/,
          );
          const videoid = youtubeMatch ? youtubeMatch[1] : "";
        } catch (error) {
          setIsLoadingGetPage(false);
          console.log("Error creating campaign:", error);
        }
      }
    }
  };

  useEffect(() => {
    if (FromEdit === "startEditing") {
      getVerifyingScript(campIdFrEdit);
      handleVerifyCheckClick(campIdFrEdit);
      cnameRec(campIdFrEdit);
    }
  }, []);

  const cnameRec = async (campIdFrEdit: string) => {
    try {
      const response = await getCnameEntriesMutation({
        email: mentor_email || getCookie("mentor_email") || "",
        campaignid: campIdFrEdit || "",
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.cnamerecords);
        setCnameDomainName(response.data);
        setCnameRecords(response.data.cnamerecords);
      }
    } catch (error) {
      console.log("Error fetching dns record:", error);
    }
  };

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({
        email: mentor_email || getCookie("mentor_email") || "",
        campaignid:
          /* campIdFrEdit || localStorage.getItem('IdChangingMode') ||  */ "",
      });
      if ("data" in response) {
        setPlanDetails(response.data.data);
        //console.log('plan details***=>', response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* const fetchDefaultPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email, campaignid: '' });
            if ('data' in response) {

                setDefaultPlanDetails(response.data.data);
                console.log('default plan details***=>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    } */

  useEffect(() => {
    // if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' || successCancelSubscription === true) {
    fetchPlanDatas();
    //console.log(planDetails);
    // }
  }, []);

  const fetchCampDatas = async () => {
    try {
      const response = await getuserCampDetails({
        campaignid:
          campIdFrEdit || /* localStorage.getItem('IdChangingMode') || */ "",
      });
      if ("data" in response) {
        setCampDetails(response.data.data);
        console.log("camp details***=>", response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (FromEdit === "startEditing") {
      fetchCampDatas();
    }
  }, []);

  /* useEffect(() => {

        fetchDefaultPlanDatas();

    }, []); */

  const autoPublishCheck = async (id: string) => {
    setIsUpdateLoader(true);
    try {
      const validVideoTag =
        videoTag?.trim() || campDetails?.videotag?.trim() || "";
      const response = await updateAutoPublishCheckMutation({
        campaign_id: id,
        autopublish: autoPublish ? 1 : 0,
        threeblogperday: limitPublish ? 1 : 0,
        addtags: addtags ? 1 : 0,
        capturleads: capturleads ? 1 : 0,
        twitterurl: planDetails?.twitterurl || twitterUrl || "",
        fburl: planDetails?.fburl || fbUrl || "",
        pintresturl: planDetails?.pintresturl || pintrestUrl || "",
        linkedinurl: planDetails?.linkedinurl || linkedinUrl || "",
        newsletter: newsletter ? 1 : 0,
        twitternbutton: twitternbutton ? 1 : 0,
        fbbutton: fbbutton ? 1 : 0,
        pintrestbutton: /* pintrestbutton ? 1 : */ 0,
        linkedinbutton: linkedinbutton ? 1 : 0,
        video: video ? 1 : 0,
        owndomain: useOwnDomain ? 1 : 0,
        cta_lable: ctaLabel
          ? encodeURIComponent(ctaLabel)
          : planDetails?.cta_lable
            ? encodeURIComponent(planDetails?.cta_lable)
            : "Learn More",
        cta_link: ctaLink
          ? encodeURIComponent(ctaLink)
          : campDetails?.cta_link
            ? encodeURIComponent(campDetails?.cta_link)
            : sourceUrl,
        videotag: encodeURIComponent(validVideoTag),
        iframe: 1,
        publish_to_ocesha: publishToOcesha ? 1 : 0,
        publish_to_code_genie: publishToCodegenie ? 1 : 0,
        competetor_search: competitorSearch ? 1 : 0,
      });
      console.log(response);
      if (FromEdit === "startEditing") {
        if ("data" in response) {
          console.log(response.data.msg);

          // toast.success(response.data.msg);
          if (FromEdit === "startEditing") {
            toast.success("Blog settings updated successfully!");
          } else {
            toast.success(response.data.msg);
          }
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setIsUpdateLoader(false);
    }
  };



  const handleCheckout = async (campaignId: string) => {
    let referral_param = localStorage.getItem("referral_param");
    localStorage.removeItem("referral_param");
    /* let couponcode = localStorage.getItem("couponcode");
        localStorage.removeItem("couponcode"); */

    try {
      const response = await createCheckoutSession({
        emailid: mentor_email || getCookie("mentor_email") || "",
        username: userDetails.name,
        subscription_level:
          selectedSubscriptionLevel /* paymentOption === '$0/mo.' ? 'level_0' : paymentOption === '$14/mo.' ? 'level_1' : paymentOption === '$39/mo.' ? 'level_2' : paymentOption === '$99/mo.' ? 'level_3' : (paymentOption === '$0/mo.' && period === 'yearly') ? 'level_0y' : paymentOption === '$82.5/mo.' ? 'level_4' : paymentOption === '$165.8/mo.' ? 'level_5' : paymentOption === '$249.16/mo.' ? 'level_6' : '' */,
        referral_param: referral_param || "",
        couponcode: couponCode ?? "",
        mode: "",
        campaignid: campaignId || "",
        from_page: "campaign",
        return_domain: "",
      });

      if (response.data.message == "Checkout url created") {
        // Assuming response contains the checkout URL
        const checkoutUrl = response.data.checkout_url;

        // Redirect to the Stripe checkout page
        window.location.href = checkoutUrl;
      } else if (response.data.error) {
        const errorMessage = response.data.error;
        if (
          errorMessage.includes(
            "This promotion code cannot be redeemed because the associated customer has prior transactions.",
          )
        ) {
          toast.error("Coupon code already applied");
        } else if (
          errorMessage.includes(
            "This coupon cannot be redeemed because it does not apply to anything in this order.",
          )
        ) {
          toast.error("Invalid Coupon code");
        } else {
          toast.error("Invalid Coupon code");
        }
      }
      /* else {
                console.log('checkout res=>', response);
                toast.error("Something went wrong, checkout url not created");
            } */
    } catch (e) {
      alert(e);
      console.log(e);
    }
  };

  const data = [
    { heading: "QUANTITY", value: "1" },
    {
      heading: "PLAN TYPE",
      value: period === "monthly" ? "Monthly" : "Yearly",
    },
    {
      heading: "PLAN NAME",
      value: planDetails
        ? planDetails.subscription_level === "level_0" ||
          planDetails.subscription_level === "level_0y"
          ? "Starter"
          : planDetails.subscription_level === "level_1" ||
            planDetails.subscription_level === "level_4"
            ? "Basic"
            : planDetails.subscription_level === "level_2" ||
              planDetails.subscription_level === "level_5"
              ? "Pro"
              : planDetails.subscription_level === "level_3" ||
                planDetails.subscription_level === "level_6"
                ? "Traffic Hacker"
                : ""
        : selectedSubscriptionLevel
          ? selectedSubscriptionLevel === "level_0" ||
            selectedSubscriptionLevel === "level_0y"
            ? "Starter"
            : selectedSubscriptionLevel === "level_1" ||
              selectedSubscriptionLevel === "level_4"
              ? "Basic"
              : selectedSubscriptionLevel === "level_2" ||
                selectedSubscriptionLevel === "level_5"
                ? "Pro"
                : selectedSubscriptionLevel === "level_3" ||
                  selectedSubscriptionLevel === "level_6"
                  ? "Traffic Hacker"
                  : ""
          : "",
    },
    {
      heading: "TOTAL",
      value: planDetails
        ? planDetails?.subscription_level === "level_0"
          ? "$49/mo."
          : planDetails?.subscription_level === "level_1"
            ? "$99/mo."
            : planDetails?.subscription_level === "level_2"
              ? "$199/mo."
              : planDetails?.subscription_level === "level_3"
                ? "$299/mo."
                : planDetails?.subscription_level === "level_0y"
                  ? "$" + (48.8 * 12).toFixed(1) + "/yr."
                  : planDetails?.subscription_level === "level_4"
                    ? "$" + (82.5 * 12).toFixed(1) + "/yr." /* '$82.5/mo.' */
                    : planDetails?.subscription_level === "level_5"
                      ? "$" +
                      (165.8 * 12).toFixed(1) +
                      "/yr." /* '$165.8/mo.' */
                      : planDetails?.subscription_level === "level_6"
                        ? "$" +
                        (249.16 * 12).toFixed(1) +
                        "/yr." /* '$249.16/mo.' */
                        : ""
        : /* paymentOption */ paymentOptYearlyCal,
    },
    // { heading: 'PAYMENT', value: <Button variant="contained" sx={{ color: '#fff' }} onClick={handleCheckout}>Pay Now</Button> }
  ];

  const handledropdownChange = (event: any) => {
    setSelectedSection(event.target.value);
  };

  const handleSourceUrlChange = (event: any) => {
    let urlVal = event.target.value;
    if (urlVal.startsWith("https://")) {
      urlVal = urlVal.replace("https://", "");
    }

    const element = document.getElementById("authurl") as HTMLInputElement;
    setSourceUrl(urlVal);
    localStorage.setItem("sourceurl", urlVal);
    if (element && !socialUrl) {
      element.value = urlVal;
      setSocialUrl(urlVal);
    }
  };

  const handleblogscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setBlogCount(value);
    } else {
      toast.error("Please enter numeric value!");
    }
  };

  const handleSourceYoutubeUrlChange = (event: any) => {
    let urlVal = event.target.value;
    if (urlVal.startsWith("https://")) {
      urlVal = urlVal.replace("https://", "");
    }

    const element = document.getElementById("authurl") as HTMLInputElement;
    setSourceYoutubeUrl(urlVal);
    if (element && !socialUrl) {
      element.value = urlVal;
      setSocialUrl(urlVal);
    }

    // localStorage.setItem('sourceurl', urlVal);
  };

  const handleSourceTextChange = (event: any) => {
    let textVal = event.target.value;
    setSourceText(textVal);
    localStorage.setItem("sourcetext", textVal);
  };

  const handlePodcastUrlChange = (event: any) => {
    let podcastVal = event.target.value;
    setPodcastOrYoutubeUrl(podcastVal);
    localStorage.setItem("podcastUrl", podcastVal);
  };

  /* useEffect(() => {
        if (sourceYoutubeUrl) {
            setVideoTag(sourceYoutubeUrl);
        } else if (planDetails?.videotag) {
            setVideoTag(planDetails?.videotag);
        } else if (planDetails?.videoid && !videoTag) {
            setVideoTag(`https://www.youtube.com/watch?v=${planDetails.videoid}`);
        }
    }, [planDetails, sourceUrl]); */

  useEffect(() => {
    if (sourceYoutubeUrl) {
      setVideoTag(sourceYoutubeUrl);
    }
  }, [sourceYoutubeUrl]);

  const handlevideotag = (event: any) => {
    let videotagg = event.target.value.trim();
    setVideoTag(videotagg);
    /* if (sourceYoutubeUrl) {
            setSourceYoutubeUrl(videotagg);
        } else */ if (campDetails) {
      setCampDetails({
        ...campDetails,
        videotag: videotagg,
      });
    }
    localStorage.setItem("videoTag", videotagg);
  };

  const handletwitterUrlChange = (event: any) => {
    let urlVal = event.target.value;
    settwitterUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        twitterurl: urlVal,
      });
    }
    localStorage.setItem("twitterurl", urlVal);
  };

  const handlefbUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setfbUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        fburl: urlVal,
      });
    }
    localStorage.setItem("fburl", urlVal);
  };

  const handlepintrestUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setPintrestUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        pintresturl: urlVal,
      });
    }
    localStorage.setItem("pintresturl", urlVal);
  };

  const handleCtaLabelChange = (event: any) => {
    let label = event.target.value;
    setCtaLabel(label);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        cta_lable: label,
      });
    }
  };

  const handleCtaLinkChange = (event: any) => {
    let link = event.target.value;
    setCtaLink(link);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        cta_link: link,
      });
    }
  };

  const handlelinkedinUrlChange = (event: any) => {
    let urlVal = event.target.value;
    setLinkedinUrl(urlVal);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        linkedinurl: urlVal,
      });
    }
    localStorage.setItem("linkedinurl", urlVal);
  };

  const handlepaymentOptions = (value: any, subscription_level: any) => {
    // const payment_Option = event?.target.value;
    setPaymentOption(value);
    setSelectedSubscriptionLevel(subscription_level);
    console.log("selecting subscription=>", selectedSubscriptionLevel);
    console.log("selected payment val=>", paymentOption);
    setPaymentOptYearlyCal(
      value === "$48.8/mo." && period === "yearly"
        ? "$" + (48.8 * 12).toFixed(1) + "/yr."
        : value === "$82.5/mo."
          ? "$" + (82.5 * 12).toFixed(1) + "/yr."
          : value === "$165.8/mo."
            ? "$" + (165.8 * 12).toFixed(1) + "/yr."
            : value === "$249.16/mo."
              ? "$" + (249.16 * 12).toFixed(1) + "/yr."
              : value,
    );
    localStorage.setItem("paymentOption", value);
    localStorage.setItem("PaymentSubscription", subscription_level);

    if (
      subscription_level == "level_0" ||
      subscription_level == "level_0y" ||
      subscription_level == "level_1" ||
      subscription_level == "level_2" ||
      subscription_level == "level_4" ||
      subscription_level == "level_5"
    ) {
      setExpanded3(false);
      setExpanded6(false);
      setExpanded7(false);
      setExpanded8(false);
      setExpanded9(false);

      setSocialMediaUrlPublish(false);
      setCapturLeads(false);
      setNewsLetter(false);
      setTwitternButton(false);
      setFbButton(false);
      setPintrestButton(false);
      setLinkedinButton(false);

      settwitterUrl("");
      setfbUrl("");
      setPintrestUrl("");
      setLinkedinUrl("");
    } else {
      setCapturLeads(true);
      setNewsLetter(true);
      setTwitternButton(true);
      setFbButton(true);
      setPintrestButton(true);
      setLinkedinButton(true);
    }
  };

  const paymentSubscription = localStorage.getItem("PaymentSubscription") || "";

  const handleAutoPublishChange = (event: any) => {
    const isChecked = event.target.checked;
    setAutopublish(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        autopublish: isChecked,
      });
    }
    localStorage.setItem("autoPublish", isChecked.toString());
  };

  const handlePublishToOceshaChange = (event: any) => {
    const isChecked = event.target.checked;
    setPublishToOcesha(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        publish_to_ocesha: isChecked,
      });
    }
    localStorage.setItem("publish_to_ocesha", isChecked.toString());
  };

  const handleCompetitorSearchChange = (event: any) => {
    const isChecked = event.target.checked;
    setCompetitorSearch(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        competetor_search: isChecked,
      });
    }
    localStorage.setItem("competitor_search", isChecked.toString());
  };

  const handlePublishToCodegenieChange = (event: any) => {
    const isChecked = event.target.checked;
    setPublishToCodegenie(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        publish_to_code_genie: isChecked,
      });
    }
    localStorage.setItem("publish_to_code_genie", isChecked.toString());
  };

  const handlelimitPublishChange = (event: any) => {
    const isChecked = event.target.checked;
    setLimitPublish(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        threeblogperday: isChecked,
      });
    }
    localStorage.setItem("limitPublish", isChecked.toString());
  };

  const handlesocialMediaUrlPublishChange = (event: any) => {
    /* if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                return false;
            } */
    const isChecked = event.target.checked;
    setSocialMediaUrlPublish(isChecked);
    if (campDetails) {
      // Update planDetails if it exists (you can add specific updates if needed)
      setCampDetails({
        ...campDetails,
        // Here you can add any relevant updates to planDetails based on isChecked
        // For example:
        socialMediaUrlPublish: isChecked,
      });
    }
    localStorage.setItem("smUrlpublish", isChecked.toString());
  };

  const handleaddtagsChange = (event: any) => {
    const isChecked = event.target.checked;
    setAddTags(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        addtags: isChecked,
      });
    }
    localStorage.setItem("addTags", isChecked.toString());
  };

  const handletocChange = (event: any) => {
    const isChecked = event.target.checked;
    setToc(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        toc: isChecked,
      });
    }
    localStorage.setItem("toc", isChecked.toString());
  };

  const handleexternalLinksChange = (event: any) => {
    const isChecked = event.target.checked;
    setExternalLinks(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        external_links: isChecked,
      });
    }
    localStorage.setItem("externalLinks", isChecked.toString());
  };

  const handlecapturleadsChange = (event: any) => {
    const isChecked = event.target.checked;
    setCapturLeads(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        capturleads: isChecked,
      });
    }
    localStorage.setItem("captureLeads", isChecked.toString());
  };

  const handlenewsletterChange = (event: any) => {
    const isChecked = event.target.checked;
    setNewsLetter(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        newsletter: isChecked,
      });
    }
    localStorage.setItem("newsLetter", isChecked.toString());
  };

  const handletwitterBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setTwitternButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        twitternbutton: isChecked,
      });
    }
    localStorage.setItem("twitterBtn", isChecked.toString());
  };

  const handlefbBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setFbButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        fbbutton: isChecked,
      });
    }
    localStorage.setItem("fbBtn", isChecked.toString());
  };

  const handlepintrestBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setPintrestButton(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        pintrestbutton: isChecked,
      });
    }
    localStorage.setItem("pintrestBtn", isChecked.toString());
  };

  const handlelinkedinBtnChange = (event: any) => {
    const isChecked = event.target.checked;
    setLinkedinButton(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        linkedinbutton: isChecked,
      });
    }
    localStorage.setItem("linkedinBtn", isChecked.toString());
  };

  const handlevideoChange = (event: any) => {
    const isChecked = event.target.checked;
    setVideo(isChecked);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        video: isChecked,
      });
    }
    localStorage.setItem("video", isChecked.toString());
  };

  const handleOwnDomainChange = (event: any) => {
    const isChecked = event.target.checked;
    setUseOwnDomain(isChecked);
    if (planDetails) {
      setPlanDetails({
        ...planDetails,
        owndomain: isChecked,
      });
    }
    localStorage.setItem("owndomain", isChecked.toString());
  };

  const handleAuthorUseDefaultChange = (event: any) => {
    const isChecked = event.target.checked;
    setUseAsDefault(isChecked);
    // if (userDetails) {
    //     setUserDetails({
    //         ...userDetails,
    //         blog_default: isChecked
    //     })
    // }
    // else
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        use_as_default: isChecked,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        blog_default: isChecked,
      });
    }
    localStorage.setItem("authorDefaultCheck", isChecked.toString());
  };

  const handleModalPayNowClick = () => {
    setOpenPaymentInstructModal(false);
    setExpanded(true);
    setTimeout(() => {
      paymentSectionRef?.current?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  const campaignIdfromsuccess = localStorage.getItem("campaignid");

  const handleTopicConfirmation = async (
    topic: any,
    keywordCount: any,
    campId: any,
  ) => {
    setIsLoadingGetPage(true);
    setLoaderProgress(8);
    setLoadingText(
      <Typography fontSize="18px">
        <b>Researching Keywords</b>
        <br />
        We’re using AI Agents to research and suggest the best keywords to get
        traffic for your blog
      </Typography>,
    );
    setTopicsList(false);
    setIsKeywordLoader(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      // const response = await axios.get(
      //     `${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`,
      // );

      // Step 1: start the task
      const { data } = await axios.get<ScrapPageResponse>(
        `${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`,
      );
      const taskId = data.task_id;

      // Step 2: poll until done
      const response2 = await waitForTaskResult(taskId, apiUrl);

      console.log("keywords response=>", response2);
      if (response2.result) {
        setLoaderProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 500));
        setIsLoadingGetPage(false);
        setKeywords(response2.data);
        setKeywordsList(true);
        setTopicsList(false);
      }
    } catch (error) {
      console.log("Error fetching keywords=>", error);
    } finally {
      setIsKeywordLoader(false);
      setLoaderProgress(40);
      setIsLoadingGetPage(false);
    }
  };

  const handleGetPageforCampaign = async (
    userEmail: any,
    campaignid: any,
    topic: any,
    keyword: any,
  ) => {
    setKeywordsList(false);
    setIsLoadingGetPage(true);
    setLoaderProgress(8);
    // if (!campIdFrEdit) {
    setLoadingText(
      <Typography fontSize="18px">
        <b>Writing Blog Content</b>
        <br />
        Our AI is now writing your blog(s) based on your content, topic, and
        keyword. We will use Google EEAT standard that will help with your blog
        ranking well in Google Search.
      </Typography>,
    );
    setIntervalTime(4000);
    // setIsLoadingGetPage(true);
    // }
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

      //const response = await getPageforCampaign({ email: userEmail || getCookie('user_email') || "", campaign_id: campaignid || '', topic: topic, keywords: keyword });

      // Step 1: Call the mutation to start the task
      const { data: taskResponse }: any = await getPageforCampaign({
        email: mentor_email || getCookie("mentor_email") || "",
        campaign_id: campaignid || "",
        topic,
        keywords: keyword,
      });

      const taskId = taskResponse.task_id;

      // Step 2: Poll until task is done or failed
      const response = await waitForTaskResult(taskId, apiUrl);

      console.log("response-------------");
      console.log(response);
      if ("data" in response) {
        //console.log('getpagecampaign=>', response.data.result);
        console.log("campIdFrEdit-------", campIdFrEdit);

        if (response.result === "success" && !campIdFrEdit) {
          setLoaderProgress(100);
          setTimeout(() => {
            localStorage.setItem("activeItem", "blogs");
            setIsLoadingGetPage(false);
            navigate("/codegenie/generated-blogs", {
              state: { FromCampaign: campaignIdfromsuccess },
            });
            // setOpenGetPageSuccessModal(true);
          }, 1000);
        } else if (response.result === "failure") {
          setGetPageError(true);
          toast.error(response.message);
        }
      } else {
        const errorMessage = (response?.error as any)?.data?.detail as
          | string
          | undefined;
        toast.error(errorMessage);
        setIsLoadingGetPage(false);
      }
    } catch (error) {
      toast.error("Error generating blogs");
      setIsLoadingGetPage(false);
      console.log("Error generating blogs:", error);
    }
  };

  /* useEffect(() => {
        if (campaignIdfromsuccess && !getpageRunref.current) {
            handleGetPageforCampaign();
            getpageRunref.current = true;
        }
    }, [campaignIdfromsuccess]) */

  const handleGetPageModalClose = async () => {
    setOpenGetPageSuccessModal(false);
    localStorage.setItem("activeItem", "blogs");
    navigate("/codegenie/generated-blogs", {
      state: { FromCampaign: campaignIdfromsuccess },
    });
    // setExpanded3(true);
    // setTimeout(() => {
    //    getcnameEntriesRef?.current?.scrollIntoView({ behavior: 'smooth' });
    // }, 300);
    setIsLoadingCnameRec(true);
    // try {
    //    const response = await getCnameEntriesMutation({ email: user_email, campaignid: campaignIdfromsuccess || '' });
    //   if ('data' in response) {
    //      console.log('cnameentries=>', response.data.cnamerecords);
    //      setCnameDomainName(response.data);
    //    setCnameRecords(response.data.cnamerecords);
    //   }
    //  } catch (error) {
    //    console.log('Error fetching dns record:', error);
    // } finally {
    //     setIsLoadingCnameRec(false);
    //    getVerifyingScript(campaignIdfromsuccess || '');
    //    // localStorage.removeItem('campaignid');
    //  }
  };

  const getVerifyingScript = async (campaignId: string) => {
    // setExpanded4(true);
    /*  setTimeout(() => {
             getVerifyScript?.current?.scrollIntoView({ behavior: 'smooth' });
         }, 300); */
    try {
      const response = await getverifyscript({
        userid: mentor_email || getCookie("mentor_email") || "",
        campaingid:
          campaignId ||
          "" /* campaignId ? campaignId : campaignIdfromsuccess || '' */,
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.script);
        setScript(response.data.script);
      }
    } catch (error) {
      console.log("fetching error", error);
    }
  };

  const handleVerifyCheckClick = async (campaignId: string) => {
    try {
      const response = await getcheckverified({
        userid: mentor_email || getCookie("mentor_email") || "",
        campaingid: campaignId /* localStorage.getItem('campaignid') */ || "",
      });
      if ("data" in response) {
        console.log("cnameentries=>", response.data.status);
        setVerifyCheck(response.data.status);
        localStorage.removeItem("campaignid");
      }
    } catch (error) {
      console.log("fetching error", error);
    }
  };

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      setUserImage(file /* e.target.files[0] */);
      setUserImageUrl(imageUrl);

      return () => URL.revokeObjectURL(imageUrl);
    }
  };

  const handleUpdateSetting = async (campaignId: string) => {
    // e.preventDefault();
    setIsUpdateLoader(true);
    let formData = new FormData();

    // let isFormValid = validateForm();
    // if (isFormValid) {
    //   setIsLoading(true);

    formData.append(
      "name",
      name != "" && name != undefined
        ? name
        : planDetails?.name === undefined
          ? userDetails?.name
          : planDetails.name /* planDetails?.name || '' */,
    );
    formData.append("campaignid", campaignId);
    if (userImage) {
      formData.append("user_image", userImage);
    }

    const element = document.getElementById("authurl") as HTMLInputElement;

    if (element.value) {
      formData.append("social_url", element.value);
    } else {
      formData.append("social_url", socialUrl);
    }

    const element1 = document.getElementById("usedefault") as HTMLInputElement;
    if (element1.checked) {
      formData.append("use_as_default", "1");
    } else {
      formData.append("use_as_default", useAsDefault ? "1" : "0");
    }

    //   formData.append('blog_default', blogDefault ? '1' : '0');
    //   formData.append('email', useremail);
    //   formData.append('auto_publish', isChecked ? `${isChecked}` : "0");
    /* if (!name || !campaignId) {
            toast.error('Please fill the required field on author section!');
        } */
    // else {
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl + "/api/prompts/updateAuthorinfo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.status == "success") {
        //   toast.success(response.data.message);
        //   setIsLoading(false);
        const randomNumber = Math.random();
        setUserImageUrl(response.data.user_image + "?" + randomNumber);
        /* if (FromEdit === 'startEditing') {
                    toast.success(response.data.message);
                } */
      } else {
        toast.error("Somethng went wrong..");
        //   setIsLoading(false);
      }
      console.log(response.data);
    } catch (error) {
      console.error("Error updating author settings:", error);
      // setIsLoading(false);
    } finally {
      setIsUpdateLoader(false);
    }
    // }

    // }
  };

  useEffect(() => {
    if (campDetails?.social_url) setSocialUrl(campDetails?.social_url);

    if (campDetails?.name) setName(campDetails?.name);

    if (campDetails?.use_as_default == 1) setUseAsDefault(true);
  }, [campDetails]);

  useEffect(() => {
    if (!campDetails?.social_url && userDetails?.social_url)
      setSocialUrl(userDetails?.social_url);

    if (!name) setName(userDetails?.name);
  }, [userDetails]);

  useEffect(() => {
    const storedCampaignName = localStorage.getItem("campaignName");
    if (storedCampaignName) {
      setCampaignName(storedCampaignName);
    }

    const storedAuthorName = localStorage.getItem("Authorname");
    if (storedAuthorName) {
      setName(storedAuthorName);
    }

    const storedAuthorurl = localStorage.getItem("Authorurl");
    if (storedAuthorurl) {
      setSocialUrl(storedAuthorurl);
    }

    const storedSourceUrl = localStorage.getItem("sourceurl");
    if (storedSourceUrl) {
      setSourceUrl(storedSourceUrl);
    }

    const storedSourceText = localStorage.getItem("sourcetext");
    if (storedSourceText) {
      setSourceText(storedSourceText);
    }

    const storedPodcastUrl = localStorage.getItem("podcastUrl");
    if (storedPodcastUrl) {
      setPodcastOrYoutubeUrl(storedPodcastUrl);
    }

    const storedtwitterUrl = localStorage.getItem("twitterurl");
    if (storedtwitterUrl) {
      settwitterUrl(storedtwitterUrl);
    }

    const storedFBUrl = localStorage.getItem("fburl");
    if (storedFBUrl) {
      setfbUrl(storedFBUrl);
    }

    const storedpintrestUrl = localStorage.getItem("pintresturl");
    if (storedpintrestUrl) {
      setPintrestUrl(storedpintrestUrl);
    }

    const storedLinkedinUrl = localStorage.getItem("linkedinurl");
    if (storedLinkedinUrl) {
      setLinkedinUrl(storedLinkedinUrl);
    }

    const payment_opt = localStorage.getItem("paymentOption");
    if (payment_opt) {
      setPaymentOption(payment_opt);
    }

    const storedAutoPublish = localStorage.getItem("autoPublish");
    if (storedAutoPublish !== null) {
      setAutopublish(storedAutoPublish === "true");
    }

    const storedLimitPublish = localStorage.getItem("limitPublish");
    if (storedLimitPublish !== null) {
      setLimitPublish(storedLimitPublish === "true");
    }

    const storedsocialMediaurlsPublish = localStorage.getItem("smUrlpublish");
    if (storedsocialMediaurlsPublish !== null) {
      setSocialMediaUrlPublish(storedsocialMediaurlsPublish === "true");
    }

    const storedAddTags = localStorage.getItem("addTags");
    if (storedAddTags !== null) {
      setAddTags(storedAddTags === "true");
    }

    const storedcaptureLeads = localStorage.getItem("captureLeads");
    if (storedcaptureLeads !== null) {
      setCapturLeads(storedcaptureLeads === "true");
    }

    const storednewsLetter = localStorage.getItem("newsLetter");
    if (storednewsLetter !== null) {
      setNewsLetter(storednewsLetter === "true");
    }

    const storedtwitterBtn = localStorage.getItem("twitterBtn");
    if (storedtwitterBtn !== null) {
      setTwitternButton(storedtwitterBtn === "true");
    }

    const storedfbBtn = localStorage.getItem("fbBtn");
    if (storedfbBtn !== null) {
      setFbButton(storedfbBtn === "true");
    }

    const storedpintrestBtn = localStorage.getItem("pintrestBtn");
    if (storedpintrestBtn !== null) {
      setPintrestButton(storedpintrestBtn === "true");
    }

    const storedlinkedinBtn = localStorage.getItem("linkedinBtn");
    if (storedlinkedinBtn !== null) {
      setLinkedinButton(storedlinkedinBtn === "true");
    }

    const storedvideo = localStorage.getItem("video");
    if (storedvideo !== null) {
      setVideo(storedvideo === "true");
    }

    const storedAuthorDefCheck = localStorage.getItem("authorDefaultCheck");
    if (storedAuthorDefCheck !== null) {
      setUseAsDefault(storedAuthorDefCheck === "true");
    }
  }, []);

  const handleCampaignNameChange = (event: any) => {
    const newName = event.target.value;
    if (newName === planDetails?.product_name) {
      toast.error("Already campaign name exist!");
    } else {
      setCampaignName(newName);
      if (planDetails) {
        setPlanDetails({
          ...planDetails,
          product_name: newName,
        });
      }
      localStorage.setItem("campaignName", newName);
    }
  };

  const handleAuthorNameChange = (event: any) => {
    const newName = event.target.value;
    setName(newName);
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        name: newName,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        name: newName,
      });
    }
    localStorage.setItem("Authorname", newName);
  };

  const handleAuthorUrlChange = (event: any) => {
    const newUrl = event.target.value;

    setSocialUrl(newUrl);
    // if (userDetails) {
    //     setUserDetails({
    //         ...userDetails,
    //         social_url: newUrl
    //     })
    // }
    // else
    if (campDetails) {
      setCampDetails({
        ...campDetails,
        social_url: newUrl,
      });
    } else if (userDetails) {
      setUserDetails({
        ...userDetails,
        social_url: newUrl,
      });
    }
    localStorage.setItem("Authorurl", newUrl);
  };

  const handleCopyName = (name: string) => {
    navigator.clipboard.writeText(name).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleCopyscript = (script: string) => {
    navigator.clipboard.writeText(script).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleCopyVal = (value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //oast.success('Copied to Clipboard!');
    });
  };

  const placeholderText = "https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s";

  const code_snippet =
    script; /* `<!- Traffic Monster tag (gtag.js) --> <script async src=https://www.googletagmanage EGRK3ZCMNX"></script> <script> window.dataLayer =
window.dataLayer || []; function gtag() {dataLayer.push(arguments) i) gtag('is' new Date gtag('config', 'G-EGRKзZCMNX');` */

  /* const handleShare = (url: any) => {
        window.open(url, '_blank');
    };

    const shareOnTwitter = () => {
        handleShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnPinterest = () => {
        handleShare(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnFacebook = () => {
        handleShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnLinkedin = () => {
        handleShare(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`);
        handleShare(`https://www.linkedin.com/sharing/share-offsite/url=${encodeURIComponent(window.location.href)}`);

    }; */

  useEffect(() => {
    setUserImageUrl(planDetails?.user_image || campDetails?.user_image);
  }, [planDetails]);

  const NormallyValArray = [
    period == "monthly" ? "" : "Normally $14/mo.",
    period == "monthly" ? "" : "Normally $49/mo.",
    period == "monthly" ? "" : "Normally $99/mo.",
    period == "monthly" ? "" : "Normally $149/mo.",
  ];

  const handleChangePayMethodClick = async () => {
    localStorage.setItem("ChangepayMode", "true");
    localStorage.setItem("IdChangingMode", campIdFrEdit);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl + `/api/subscription/change_payment_method?email=${mentor_email}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.status === "success") {
        window.open(response.data.portal_url, "_blank");
      }
    } catch (error) {
      console.log("Error changing payment method", error);
    }
  };

  const handleCancelSubscriptionClick = async () => {
    setCancellingLoader(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        apiUrl +
        `/api/subscription/Cancel_Subscription?campaign_id=${campIdFrEdit}`,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        },
      );
      if (response.data.status === "success") {
        setSuccessCancelSubscription(true);
        setConfirmCancelSubscription(false);
        toast.success("Cancelled Subscription!");
      }
    } catch (error) {
      toast.error("Error cancelling subscription");
      console.log("Error cancelling subscription", error);
    } finally {
      setCancellingLoader(false);
    }
  };

  const currentlocationurl = window.location.origin;
  const addtoMyblogscodeSnippet = `<iframe src="${currentlocationurl}/blogs?campaignid=${campIdFrEdit}&header=off" height="600" width="900" title="Iframe Example"></iframe>`;

  const handleCopyCodeSnippet = (value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success(
        'Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.',
        {
          style: { whiteSpace: "pre-line", width: "300px" },
          autoClose: 15000,
        },
      );
      //toast.success('Copied to Clipboard!');
    });
  };

  const handleuploadvideoChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const apiUrl: string = process.env.REACT_APP_UPLOAD_SERVER_ENDPOINT || "";
    const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB
    const CONCURRENCY = 20;
    const RETRIES = 3;

    // UI state
    if (urlPrefix === "word" || urlPrefix === "pdf") {
      setLoadingText("Uploading your document...");
    } else {
      setLoadingText("Uploading your video...");
    }
    setUploadVideo(file.name);
    setIsLoadingGetPage(true);
    setLoaderProgress(0);
    //setLoaderProgress(5);

    // helpers
    const splitIntoChunks = (f: File, chunkSize: number) => {
      const parts: { index: number; start: number; end: number; blob: Blob }[] =
        [];
      let idx = 0;
      for (let start = 0; start < f.size; start += chunkSize) {
        const end = Math.min(start + chunkSize, f.size);
        parts.push({ index: idx++, start, end, blob: f.slice(start, end) });
      }
      return parts;
    };

    const initUpload = async (
      filename: string,
      totalSize: number,
      chunkSize: number,
    ) => {
      const form = new FormData();
      form.append("filename", filename);
      form.append("total_size", String(totalSize));
      form.append("chunk_size", String(chunkSize));
      const resp = await axios.post(`${apiUrl}/upload/init`, form);
      return resp.data as {
        upload_id: string;
        total_chunks: number;
        chunk_size: number;
      };
    };

    const getStatus = async (uploadId: string) => {
      try {
        const resp = await axios.get(`${apiUrl}/upload/${uploadId}/status`);
        return resp.data as { uploaded: number[] };
      } catch (err) {
        return { uploaded: [] };
      }
    };

    const uploadChunk = async (uploadId: string, index: number, blob: Blob) => {
      // form field names: index, chunk (server expects chunk)
      const form = new FormData();
      form.append("index", String(index));
      form.append("chunk", blob, `chunk_${index}`);
      return axios.post(`${apiUrl}/upload/${uploadId}/chunk`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 0, // disable timeout for big chunk uploads
      });
    };

    const completeUpload = async (uploadId: string) => {
      const resp = await axios.post(`${apiUrl}/upload/${uploadId}/complete`);
      console.log("resp.data");
      console.log(resp.data);
      return resp.data;
    };

    try {
      // 1) init (or reuse existing upload_id for this filename if present)
      //let uploadId: string | null = localStorage.getItem(`upload_id:${file.name}`) || null;
      let uploadId: string | null = null;
      let initResp: {
        upload_id: string;
        total_chunks: number;
        chunk_size: number;
      } | null = null;
      if (uploadId) {
        // verify status
        const status = await getStatus(uploadId);
        // if status empty, re-init
        if (!status || !Array.isArray(status.uploaded)) {
          uploadId = null;
          localStorage.removeItem(`upload_id:${file.name}`);
        }
      }

      if (!uploadId) {
        initResp = await initUpload(file.name, file.size, CHUNK_SIZE);
        uploadId = initResp.upload_id;
        // save for resume
        localStorage.setItem(`upload_id:${file.name}`, uploadId);
      } else {
        // fetch metadata from server - we still need total_chunks/chunk_size
        // try to call /upload/{uploadId}/status for chunk_size info or re-init
        const status = await getStatus(uploadId);
        // if we don't have chunk size, re-init
        initResp = {
          upload_id: uploadId,
          total_chunks: Math.ceil(file.size / CHUNK_SIZE),
          chunk_size: CHUNK_SIZE,
        };
      }

      //setLoaderProgress(10);

      // 2) build chunk list and skip already-uploaded
      const chunks = splitIntoChunks(file, CHUNK_SIZE);
      const statusResp = await getStatus(uploadId);
      const uploadedSet = new Set<number>(
        (statusResp.uploaded || []).map((n: number) => Number(n)),
      );
      const pending = chunks.filter((c) => !uploadedSet.has(c.index));

      if (pending.length === 0) {
        console.log("before comp.data");
        // nothing to upload, just complete
        const comp = await completeUpload(uploadId);
        console.log("comp.data");
        console.log(comp.data);
        setUploadedvideopath(comp.data || comp); // adapt to your response
        toast.success("File Uploaded Successfully!");
        setLoaderProgress(100);
        setTimeout(() => setIsLoadingGetPage(false), 1000);
        return;
      }

      // 3) upload chunks with concurrency and retries
      let uploadedBytes = (chunks.length - pending.length) * CHUNK_SIZE;
      const totalBytes = file.size;
      setLoaderProgress(Math.round((uploadedBytes / totalBytes) * 100));

      // worker pool: process pending in batches of CONCURRENCY
      const queue = [...pending]; // shallow copy

      const uploadWorker = async () => {
        while (queue.length > 0) {
          const c = queue.shift();
          if (!c) break;
          let attempt = 0;
          while (attempt < RETRIES) {
            attempt++;
            try {
              await uploadChunk(uploadId!, c.index, c.blob);
              // success
              uploadedBytes += c.end - c.start;
              const pct = Math.min(
                100,
                Math.round((uploadedBytes / totalBytes) * 100),
              );
              setLoaderProgress(10 + Math.round(pct * 0.85)); // scale to UI (10..95)
              break;
            } catch (err) {
              console.warn(`Chunk ${c.index} attempt ${attempt} failed`, err);
              if (attempt >= RETRIES) throw err;
              // backoff
              await new Promise((res) => setTimeout(res, 500 * attempt));
            }
          }
        }
      };

      // start worker pool
      const workers = new Array(Math.min(CONCURRENCY, pending.length))
        .fill(null)
        .map(() => uploadWorker());
      await Promise.all(workers);

      // 4) complete
      setLoaderProgress(95);
      const completeResp = await completeUpload(uploadId);
      // handle response (adjust the key depending on your server)
      const finalPath = completeResp.data || completeResp;
      setUploadedvideopath(finalPath);
      toast.success("File Uploaded Successfully!");

      // cleanup
      localStorage.removeItem(`upload_id:${file.name}`);
      setLoaderProgress(100);
    } catch (err) {
      console.error("Upload failed", err);
      toast.error("Error uploading video");
      setLoaderProgress(0);
      // do not remove stored upload_id so user can retry/resume
    } finally {
      setTimeout(() => setIsLoadingGetPage(false), 1000);
    }
  };

  useEffect(() => {
    setNewsLetter(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setCapturLeads(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setTwitternButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setFbButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setLinkedinButton(
      !!planDetails?.embed_contact_form_newsletters_social_media_share,
    );
    setVideo(!!planDetails?.embed_youtube_video);
  }, [planDetails]);

  const clearCookies = () => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name] = cookie.split("=");
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
    }
  };

  const Chip = ({ label }: { label: string }) => (
    <Box
      sx={{
        px: 2,
        py: 0.5,
        borderRadius: "8px",
        background: "#1F2937",
        color: "#E5E7EB",
        fontSize: "13px",
        fontWeight: 500,
      }}
    >
      {label}
    </Box>
  );

  const handleItemClick = (itemName: any) => {
    localStorage.setItem("activeItem", itemName);
    // setActiveItem(
    //   localStorage.getItem("activeItem")
    //     ? localStorage.getItem("activeItem")
    //     : itemName,
    // ); 
    setActiveItem(itemName);
    localStorage.removeItem("campaignid");
    localStorage.removeItem("returningtocampaign");
    localStorage.removeItem("sourceurl");
    localStorage.removeItem("campaignName");
    localStorage.removeItem("paymentOption");
    localStorage.removeItem("autoPublish");
    localStorage.removeItem("limitPublish");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("addTags");
    localStorage.removeItem("captureLeads");
    localStorage.removeItem("newsLetter");
    localStorage.removeItem("twitterBtn");
    localStorage.removeItem("fbBtn");
    localStorage.removeItem("pintrestBtn");
    localStorage.removeItem("linkedinBtn");
    localStorage.removeItem("video");
    localStorage.removeItem("twitterurl");
    localStorage.removeItem("fburl");
    localStorage.removeItem("pintresturl");
    localStorage.removeItem("linkedinurl");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("owndomain");
    localStorage.removeItem("ChangepayMode");
    localStorage.removeItem("IdChangingMode");
    localStorage.removeItem("PaymentSubscription");
    localStorage.removeItem("Authorurl");
    localStorage.removeItem("Authorname");
    localStorage.removeItem("authorDefaultCheck");
    localStorage.removeItem("videoTag");
    localStorage.removeItem("podcastUrl");
    localStorage.removeItem("sourcetext");

    if (itemName == "createcontent") {
      navigate("/codegenie/new-podcast");
    } else if (itemName == "createcourse") {
      localStorage.setItem("nextpage", "createcourse3");
      localStorage.setItem("activeItem", "createcourse");
      setActiveItem(itemName);
      navigate("/codegenie/generated-blogs");
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      navigate("/codegenie/generated-blogs");
    }

    if (itemName === "upgrade") {
      /*  const value = {
                 _id: "",
                 product_name: "CodeGenie",
                 product_module: genieSelector.module ? genieSelector.module : "",
                 userid: "",
                 productid: ""
             };
             getProduct(value); */
      localStorage.setItem("fromUpgrade", "true");
      navigate("/pricing", {
        state: {
          campIdFromUpgrade:
            localStorage.getItem("campId") || "" /* selectedCampaign */,
          from_page: "blog_listing",
        },
      });
    } else if (itemName === "digital") {
      setActiveItem("digital");
    } else if (itemName === "logout") {
      clearCookies();
      localStorage.setItem("logged_in", "false");
      //console.log("loggedin:" + localStorage.getItem("logged_in"));
      dispatch(logout());
      var module = localStorage.getItem("module");
      console.log("module111...." + module);

      toast.success("Logout success");
      // localStorage.removeItem("payment");
      localStorage.removeItem("msg");
      localStorage.removeItem("complexity");
      localStorage.removeItem("module");
      localStorage.removeItem("subscription_level");
      localStorage.removeItem("free_plan");
      // localStorage.removeItem("userRole");
      localStorage.removeItem("localStorage_msg");
      localStorage.removeItem("allSet");
      localStorage.removeItem("Blogs Generated");
      localStorage.removeItem("remaining_wish_count");
      localStorage.removeItem("userRole");
      localStorage.removeItem("payment");
      localStorage.removeItem("user_email");
      localStorage.removeItem("logged_in");
      localStorage.removeItem("prevImg");
      localStorage.removeItem("fromUpgrade");
      localStorage.removeItem("blogsCount");
      localStorage.removeItem("Generating Count");
      localStorage.removeItem("finalData");
      localStorage.removeItem("user_pass");
      localStorage.removeItem("fromNewcampaign");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("campId");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("smUrlpublish");
      localStorage.removeItem("addTags");
      localStorage.removeItem("captureLeads");
      localStorage.removeItem("newsLetter");
      localStorage.removeItem("twitterBtn");
      localStorage.removeItem("fbBtn");
      localStorage.removeItem("pintrestBtn");
      localStorage.removeItem("linkedinBtn");
      localStorage.removeItem("video");
      localStorage.removeItem("twitterurl");
      localStorage.removeItem("fburl");
      localStorage.removeItem("pintresturl");
      localStorage.removeItem("linkedinurl");
      localStorage.removeItem("owndomain");
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      localStorage.removeItem("user_name");
      localStorage.removeItem("refreshCount");
      localStorage.removeItem("publishingCampId");
      localStorage.removeItem("Authorurl");
      localStorage.removeItem("Authorname");
      localStorage.removeItem("authorDefaultCheck");
      localStorage.removeItem("appsumo_coupon_code");
      localStorage.removeItem("podcastUrl");
      localStorage.removeItem("AlertMessage");
      localStorage.removeItem("CreatingfromLanding");
      localStorage.removeItem("UrlfromLanding");
      localStorage.removeItem("signedup");
      localStorage.removeItem("uploadedvideo");
      localStorage.removeItem("uploadedVideoName");
      localStorage.removeItem("uploadStatus");
      localStorage.removeItem("editedposthashtags");
      localStorage.removeItem("editedpostblogsummary");
      localStorage.removeItem("editedpostblogtitle");
      localStorage.removeItem("editedposturl");
      localStorage.removeItem("user_email");
      localStorage.removeItem("YoutubeUrlfromLanding");
      localStorage.removeItem("FirstLogin");
      localStorage.removeItem("DirectSignup");
      localStorage.removeItem("FromIndexPage");
      localStorage.removeItem("activeItem");
      localStorage.removeItem("UpdateduserImage");
      localStorage.removeItem("publish_to_code_genie");
      localStorage.removeItem("publish_to_ocesha");
      localStorage.removeItem("competitor_search");
      localStorage.removeItem("FromEditBlog");
      localStorage.removeItem("ErrorAlert");
      localStorage.removeItem("FromSignIn");
      removeCookie("user_email");
      localStorage.clear();

      if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
        navigate("/Anycode_landing");
      else window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN||''; //"https://ocesha.ai";
    }
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTopicSelect = (topic: any) => {
    setSelectedTopic(topic);
  };

  const handleKeywordSelect = (keyword: any) => {
    setSelectedKeyword(keyword);
  };

  const [progress, setProgress] = useState(65);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 1 : 100));
    }, 7000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!progress) return;

    const id = setInterval(() => {
      setActiveLoadingCard((p) => (p === loadingCards.length - 1 ? 0 : p + 1));
    }, 2000);

    return () => clearInterval(id);
  }, [progress]);

  const loadingCards = [
    {
      heading: "Content Generated from Your Uploads",
      sub: "We've transformed your long-form videos, podcasts, and documents into",
      items: [
        {
          title: "Viral Video Clips",
          desc: "Short-form clips optimized for Shorts, Reels, TikToks",
          icon: <OndemandVideoIcon sx={{ color: '#4BA5EB' }} />,
        },
        {
          title: "SEO-Optimized Blogs/Articles",
          desc: "Full written content created from your video/audio transcripts",
          icon: <ArticleIcon sx={{ color: '#4BA5EB' }} />,
        },
        {
          title: "AI-Generated Images",
          desc: "Thumbnails and social visuals based on your topic and content",
          icon: <ImageIcon sx={{ color: '#4BA5EB' }} />,
        },
        {
          title: "Social Media Posts",
          desc: "Captions and posts automatically created for each clip, blog, and image",
          icon: <CampaignIcon sx={{ color: '#4BA5EB' }} />,
        },
        {
          title: "Full Transcripts",
          desc: "Audio + video transcribed and formatted for search and repurposing",
          icon: <ArticleIcon sx={{ color: '#4BA5EB' }} />,
        },
      ],
    },

    {
      heading: "Your AI-Powered Course Creation",
      sub: "Your course materials are being built automatically",
      items: [
        {
          title: "Up to 50 courses generated (Elite Plan)",
          desc: "",
          icon: <SchoolIcon sx={{ color: '#10b981' }} />,
        },
        { title: "AI Course Builder activated", desc: "", icon: <PsychologyIcon sx={{ color: '#10b981' }} /> },
        {
          title: "AI-created scripts & full lesson content",
          desc: "",
          icon: <EditNoteIcon sx={{ color: '#10b981' }} />,
        },
        {
          title: "Quizzes and worksheets generated for each module",
          desc: "",
          icon: <QuizIcon sx={{ color: '#10b981' }} />,
        },
        { title: "Completion certificates included", desc: "", icon: <VerifiedUserIcon sx={{ color: '#10b981' }} /> },
        { title: "Everything is fully editable", desc: "", icon: <QuizIcon sx={{ color: '#10b981' }} /> },
      ],
    },

    {
      heading: "Digital Twin Instructor",
      sub: "Your personal Digital Twin is being created and trained",
      items: [
        { title: "Voice cloning completed", desc: "", icon: <RecordVoiceOverIcon sx={{ color: '#8B5CF6' }} /> },
        {
          title: "Digital Twin will teach your course",
          desc: "",
          icon: <PsychologyIcon sx={{ color: '#8B5CF6' }} />,
        },
        {
          title: "Course narration generated using your cloned voice",
          desc: "",
          icon: <EditNoteIcon sx={{ color: '#10b981' }} />,
        },
        {
          title:
            "Trained on all uploaded content (audio, video, documents, transcripts)",
          desc: "",
          icon: <QuizIcon sx={{ color: '#10b981' }} />,
        },
      ],
    },

    {
      heading: "Monetization & Sales Setup",
      sub: "We're preparing everything you need to start earning",
      items: [
        { title: "Monetization enabled", desc: "", icon: <AttachMoneyIcon sx={{ color: '#F59E0B' }} /> },
        { title: "Stripe Connect integrated", desc: "", icon: <PaymentIcon sx={{ color: '#F59E0B' }} /> },
        {
          title:
            "Courses can be published and sold as soon as assets are ready",
          desc: "",
          icon: <CampaignIcon sx={{ color: '#F59E0B' }} />,
        },
        {
          title:
            "Full editing tools for videos, blogs, posts, quizzes, and course modules",
          desc: "",
          icon: <EditNoteIcon sx={{ color: '#F59E0B' }} />,
        },
      ],
    },

    {
      heading: "We're Building Everything for You",
      sub: "We're generating your entire content package now",
      items: [
        { title: "Transcribing your audio & video", desc: "", icon: <TranscribeIcon sx={{ color: '#EC4899' }} /> },
        { title: "Creating viral clips", desc: "", icon: <VideoFileIcon sx={{ color: '#EC4899' }} /> },
        { title: "Writing blogs & social posts", desc: "", icon: <ArticleIcon sx={{ color: '#EC4899' }} /> },
        { title: "Generating images", desc: "", icon: <ImageIcon sx={{ color: '#EC4899' }} /> },
        { title: "Training your Digital Twin", desc: "", icon: <PsychologyIcon sx={{ color: '#10b981' }} /> },
        { title: "Building course modules", desc: "", icon: <SchoolIcon sx={{ color: '#EC4899' }} /> },
      ],
    },
  ];

  const GeneratedItem = ({
    title,
    description,
    icon,
  }: {
    title: string;
    description: string;
    icon: any;
  }) => (
    <Stack direction="row" spacing={2} mb={2} alignItems="flex-start">
      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{icon}</Box>

      <Box>
        <Typography
          color={
            activeLoadingCard === 1 ||
              activeLoadingCard === 2 ||
              activeLoadingCard === 3 ||
              activeLoadingCard === 4
              ? "#fff"
              : "#8B5CF6"
          }
          fontWeight="bold"
        >
          {title}
        </Typography>
        <Typography color="#D1D5DB" fontSize="14px">
          {description}
        </Typography>
      </Box>
    </Stack>
  );

  const cardData = progress ? loadingCards[activeLoadingCard] : loadingCards[0];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Header />
      <div style={{ overflowX: "hidden" }}>
        <div className="row">

          <div className="overlay-container">
            <div style={{ width: "98%", marginBottom: "10%" }}>
              <Box
                sx={{
                  px: { xs: 2, md: 4 },
                  py: 4,
                  minHeight: "100vh",
                }}
              >
                {/*  HEADER ROW */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 3,
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  {/* LEFT - TITLE */}
                  <Typography
                    color="#fff"
                    fontWeight={600}
                    fontSize="32px"
                  >
                    Courses
                  </Typography>

                  {/* RIGHT - CREATE BUTTON */}
                </Box>

                {/*  TABS (ONLY FOR STUDENT) */}
                {userDetails?.role === "student" && (
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    textColor="inherit"
                    indicatorColor="primary"
                    sx={{
                      mb: 3,
                      "& .MuiTab-root": {
                        color: "#9CA3AF",
                        textTransform: "none",
                        fontSize: "18px",
                      },
                      "& .Mui-selected": {
                        color: "#fff",
                        fontWeight: 600,
                      },
                    }}
                  >
                    <Tab label="Available Courses" />
                    <Tab label="Enrolled Courses" />
                  </Tabs>
                )}

                <Grid container spacing={3}>
                  {loadingcourses ? (
                    [...Array(4)].map((_, index) => (
                      <Grid item xs={12} sm={6} md={3}>
                        <Card
                          sx={{
                            height: "100%",
                            background: "transparent",
                            borderRadius: "14px",
                            boxShadow: "none",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            border: "1px solid #2D2D2D",
                          }}
                        >
                          {/* Image section */}
                          <Box
                            sx={{
                              position: "relative",
                              height: 170,
                              overflow: "hidden",
                              p: 2,
                            }}
                          >
                            <Skeleton
                              variant="rounded"
                              width="100%"
                              height="100%"
                              sx={{ borderRadius: "20px" }}
                            />
                          </Box>

                          <CardContent
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.8,
                              p: 2,
                            }}
                          >
                            {/* title + edit */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Skeleton
                                variant="text"
                                width="70%"
                                height={26}
                              />
                              <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                              />
                            </Box>

                            {/* author */}
                            <Skeleton
                              variant="text"
                              width="40%"
                              height={18}
                            />

                            {/* description */}
                            <Skeleton
                              variant="text"
                              width="100%"
                              height={20}
                            />
                            <Skeleton
                              variant="text"
                              width="80%"
                              height={20}
                            />

                            {/* rating */}
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Skeleton
                                variant="rounded"
                                width={110}
                                height={24}
                              />
                              <Skeleton
                                variant="rounded"
                                width={80}
                                height={24}
                              />
                            </Stack>

                            {/* price */}
                            <Skeleton
                              variant="text"
                              width="30%"
                              height={22}
                            />

                            <Box sx={{ flexGrow: 1 }} />

                            {/* button */}
                            <Skeleton
                              variant="rounded"
                              width="100%"
                              height={36}
                            />
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  ) : courses && courses.length > 0 ? (
                    courses?.map((course: any) => {
                      const isEnrolled = enrolledCourseIds.includes(
                        course._id,
                      );
                      return (
                        <Grid item xs={12} sm={6} md={3} key={course._id}>
                          <Card
                            sx={{
                              height: "100%",
                              background: "transparent",
                              borderRadius: "14px",
                              boxShadow: "none",
                              overflow: "hidden",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #2D2D2D",
                            }}
                          >
                            {/* Image section */}
                            <Box
                              sx={{
                                position: "relative",
                                height: 220,
                                overflow: "hidden",
                                p: 2,
                              }}
                            >
                              <Box
                                component="img"
                                src={
                                  course.image_path_small ||
                                  course.thumbnail_url ||
                                  course.image_url ||
                                  course.image_path ||
                                  course.image ||
                                  ""
                                }
                                alt={course.title}
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  display: "block",
                                  borderRadius: "14px",
                                  cursor: "pointer",
                                  // borderRadius: '20px'
                                }}
                                // onClick={() => navigate('/codegenie/course-detail', { state: { courseId: course._id } })}
                                onClick={() => {
                                  if (isEnrolled && tabValue === 0) return;

                                  navigate(
                                    userDetails?.role === "student" && tabValue === 0
                                      ? "/codegenie/individual-course"
                                      : "/codegenie/course-detail",
                                    {
                                      state:
                                        userDetails?.role === "student" && tabValue === 0
                                          ? {
                                            studentEmail: mentor_email,
                                            courseId: course._id,
                                          }
                                          : { courseId: course._id },
                                    }
                                  );
                                }}
                              />

                              <MuiChip
                                label="BESTSELLER"
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: 25,
                                  left: 25,
                                  fontSize: "16px",
                                  height: 25,
                                  borderRadius: "4px",
                                  // backgroundColor: "#6b7280",
                                  backgroundColor: "rgba(34, 43, 89, 0.63)",
                                  color: "#fff",
                                }}
                              />
                            </Box>

                          

                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.8,
                                p: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  fontSize="20px"
                                  // fontWeight={600}
                                  color="#ffffff"
                                  sx={{
                                    textAlign: "left" /* , width: '75%' */,
                                    cursor: "pointer",
                                  }}
                                  // onClick={() => navigate('/codegenie/course-detail', { state: { courseId: course._id } })}
                                  onClick={() => {
                                    if (isEnrolled && tabValue === 0) return;

                                    navigate(
                                      userDetails?.role === "student" &&
                                        tabValue === 0
                                        ? "/codegenie/individual-course"
                                        : "/codegenie/course-detail",
                                      {
                                        state:
                                          userDetails?.role === "student" &&
                                            tabValue === 0
                                            ? {
                                              studentEmail: mentor_email,
                                              courseId: course._id,
                                            }
                                            : { courseId: course._id },
                                      },
                                    );
                                  }}
                                >
                                  {course.title?.slice(0, 18) + "..."}
                                </Typography>
                              </Box>

                              <Typography
                                fontSize="14px"
                                color="#fff"
                                fontWeight={"lighter"}
                              >
                                {/* by {course.author} */}
                                by {course.mentor_email /* course.name */}
                              </Typography>
                              <Typography
                                fontSize="18px"
                                color="#F3F3F3"
                                sx={{
                                  minHeight: 34,
                                  mt: 1,
                                  fontWeight: "lighter",
                                  textAlign: "left",
                                }}
                              >
                                {course.description?.slice(0, 40) + "..."}
                              </Typography>

                              {/* rating */}
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box display="flex">
                                  {renderStars(course?.average_rating)}
                                </Box>

                                <Typography fontSize="14px" fontWeight={600}>
                                  {course?.average_rating ?? 0}
                                </Typography>

                                <Typography fontSize="13px" color="gray">
                                  {course?.total_reviews ?? 0} reviews
                                </Typography>
                              </Box>

                              {/* price */}
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                mt={0.5}
                              >
                                <Typography
                                  fontWeight={600}
                                  color="#fff"
                                  fontSize="20px"
                                >
                                  ${course.suggested_price + " USD"}
                                </Typography>

                                {/* <Typography
                                                                fontSize="12px"
                                                                color="#9CA3AF"
                                                                sx={{ textDecoration: "line-through" }}
                                                            >
                                                                ${course.oldPrice}
                                                            </Typography> */}
                              </Stack>

                              <Box sx={{ flexGrow: 1 }} />

                              <Button
                                fullWidth
                                variant="contained"
                                disabled={isEnrolled && tabValue === 0}
                                sx={{
                                  mt: 1,
                                  textTransform: "none",
                                  borderRadius: "4px",
                                  background:
                                    isEnrolled && tabValue === 0
                                      ? "#6b7280"
                                      : "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                  fontSize: "16px",
                                  py: 0.8,
                                  color: "#fff",
                                  filter:
                                    isEnrolled && tabValue === 0
                                      ? "blur(0.3px)"
                                      : "none",
                                  pointerEvents:
                                    isEnrolled && tabValue === 0
                                      ? "none"
                                      : "auto",
                                }}
                                onClick={() => {
                                  if (isEnrolled && tabValue === 0) return;

                                  navigate(
                                    userDetails?.role === "student" &&
                                      tabValue === 0
                                      ? "/codegenie/individual-course"
                                      : "/codegenie/course-detail",
                                    {
                                      state:
                                        userDetails?.role === "student" &&
                                          tabValue === 0
                                          ? {
                                            studentEmail: mentor_email,
                                            courseId: course._id,
                                          }
                                          : { courseId: course._id },
                                    },
                                  );
                                }}
                              >
                                {/*  View Course <ArrowForwardIcon /> */}
                                {isEnrolled && tabValue === 0
                                  ? "Enrolled"
                                  : "View Course"}{" "}
                                {!isEnrolled && <ArrowForwardIcon />}
                              </Button>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          color: "#fff",
                          mt: 4,
                          fontSize: "18px",
                        }}
                      >
                        No data available
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                {courses && courses.length > 0 && (
                  <Stack alignItems="center" mt={4}>
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={(e: any, value: any) => setPage(value)}
                      color="primary"
                    />
                  </Stack>
                )}
              </Box>
            </div>
          </div>

        </div>
      </div>

      <Modal
        open={openpaymentInstructModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 600,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          {/* <Typography sx={{ fontSize: '25px' }}>ThankYou!</Typography> */}
          <PriorityHighIcon style={{ color: "yellow", fontSize: "38px" }} />
          <p
            id="child-modal-description"
            style={{
              textAlign:
                "center" /* , fontSize: 'xx-large', marginTop: '22px' */,
            }}
          >
            Please make a payment to complete your process.
          </p>
          <Stack flexDirection="row">
            <Button
              onClick={handleModalPayNowClick}
              variant="contained"
              sx={{ mr: 2 }}
            >
              Pay Now
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={openGetPagesuccessModal}
        onClose={() => setOpenGetPageSuccessModal(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 600,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          <TaskAltIcon style={{ color: "green", fontSize: "40px" }} />
          <p id="child-modal-description" style={{ textAlign: "center" }}>
            We have generated your first blogs. We will automatically generate
            new blogs daily per your selected plan. You can edit each blog from
            the My Blog page with the Edit button and Export the blogs to social
            media or blogging platforms with the Export button. Use the Help
            button on each page to learn more.
          </p>
          <Stack flexDirection="row">
            {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}

            <Button
              onClick={handleGetPageModalClose}
              variant="contained"
              sx={{ mr: 2 }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={confirmCancelSubscription}
        onClose={() => setConfirmCancelSubscription(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 800,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
          }}
        >
          <InfoIcon style={{ color: "Orange", fontSize: "40px" }} />
          <p
            id="child-modal-description"
            style={{ textAlign: "center", color: "#fff" }}
          >
            When you cancel your subscription you are also canceling the hosting
            of your blog pages. If you would like to keep this content, please
            copy the content to use on a different platform. Once cancelled the
            content will be archived for 30 days then it will be deleted from
            the Traffic Monster servers and from Google Indexing.
          </p>
          <Stack flexDirection="row" sx={{ gap: "10px", marginTop: "2%" }}>
            {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}
            <Button
              onClick={handleCancelSubscriptionClick}
              variant="contained"
              sx={{ /* mr: 2, */ fontWeight: "bolder", fontSize: "17px" }}
            >
              {cancellingLoader ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                "Continue"
              )}
            </Button>
            <Button
              onClick={() => setConfirmCancelSubscription(false)}
              variant="contained"
              sx={{ /* mr: 2, */ fontWeight: "bolder", fontSize: "17px" }}
            >
              Exit
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={upgradeModal}
        /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "40%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: "15px",
            padding: "3%",
          }}
        >
          <Typography style={{ textAlign: "center", fontWeight: "bold" }}>
            <InfoIcon sx={{ color: "#ffcc00" }} />
            <br />
            {((sourceUrl || userBusinessText) &&
              blogcount > planDetails?.blog_count_balance) ||
              ((sourceYoutubeUrl || uploadedvideopath) &&
                blogcount > planDetails?.podcast_count_balance)
              ? "Blog count exceeds your plan limit. Please upgrade your plan to continue."
              : "This feature is not included in your plan.  Please upgrade to have access to this feature."}
          </Typography>

          <Stack
            flexDirection="row"
            sx={{ display: "flex", gap: "10px", marginTop: "1%" }}
          >
            {/* <Button
                            variant="contained"
                            onClick={() => {
                                const value = {
                                    _id: "",
                                    product_name: "CodeGenie",
                                    product_module: genieSelector.module ? genieSelector.module : "",
                                    userid: "",
                                    productid: ""
                                };
                                getProduct(value);
                                localStorage.setItem('fromUpgrade', 'true');
                                navigate('/pricing');
                            }}>
                            Upgrade
                        </Button> */}

            <Button
              onClick={() => setUpgradeModal(false)}
              variant="contained"
            // sx={{ mr: 2, marginTop: '15%' }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={helperPopup}
        /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "70%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: "15px",
            padding: "3%",
          }}
        >
          {/* <video
                        controls
                        style={{ width: '100%' }}
                        src={helpervideosrc}
                        autoPlay
                    /> */}
          <iframe
            width="100%"
            height="500"
            src={helpervideosrc}
            title="Help Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <Stack flexDirection="row">
            <Button
              onClick={() => setHelperPopup(false)}
              variant="contained"
              sx={{ mr: 2, marginTop: "15%" }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={topicsList}
        // onClose={() => setTopicsList(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%", // Adjusted width for responsiveness
            maxWidth: 1000,
            bgcolor: "#36393F",
            border: "none",
            pt: 2,
            px: 4,
            pb: 3,
            height: "85%",
            maxHeight: "110vh",
            overflow: "auto",
            borderRadius: "8px",
            boxShadow: "0px 50px 50px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Stack width="100%">
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  style={{ color: "#fff" }}
                >
                  Blog Topics
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="normal"
                  style={{ color: "#fff" }}
                >
                  Below are some suggested topics to write about. You can also
                  give us a different topic below. Our AI will write about this
                  topic using the content you provided.
                </Typography>
              </Grid>
            </Grid>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#CBCBCB",
                marginTop: "1%",
              }}
            />
            <Box
              sx={{
                maxHeight: "38vh",
                overflowY: "auto",
                marginTop: "1%",
              }}
            >
              <RadioGroup
                value={selectedTopic}
                onChange={(e) => handleTopicSelect(e.target.value)}
              >
                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                  {topics &&
                    topics?.map((topic: any, index: any) => (
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{ padding: "0.5%", height: "50px" }}
                        key={index}
                      >
                        <Button
                          fullWidth
                          color="primary"
                          sx={{
                            textAlign: "left",
                            bgcolor:
                              selectedTopic === topic
                                ? "#0168B5"
                                : "transparent",
                            color: selectedTopic === topic ? "#fff" : "#CBCBCB",
                            borderColor: "#CBCBCB",
                            "&:hover": { bgcolor: "#0168B5", color: "#fff" },
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            // minHeight: '30px'
                          }}
                          onClick={() => handleTopicSelect(topic)}
                        >
                          <Radio
                            checked={selectedTopic === topic}
                            value={topic}
                            sx={{
                              color: "#CBCBCB",
                              "&.Mui-checked": { color: "#4BA5EB" },
                            }}
                          />
                          {topic.replace(/-/g, " ")}
                        </Button>
                      </Grid>
                    ))}
                </Grid>
              </RadioGroup>
            </Box>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#CBCBCB",
                marginTop: "1%",
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ color: "#fff", textAlign: "center" }}
            >
              Or
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              // label="Selected Topic"
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
              // InputProps={{ readOnly: true }}
              sx={{ mt: 3, bgcolor: "#35353C", borderRadius: "5px" }}
              placeholder="Input your topic here"
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                // color="primary"
                disabled={!selectedTopic}
                // onClick={() => handleGetPageforCampaign(campaignId, selectedTopic)}
                onClick={() =>
                  handleTopicConfirmation(selectedTopic, 10, campaignId)
                }
                sx={{ color: "#fff" }}
              >
                {isKeywordLoader ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Continue"
                )}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={keywordsList}
        // onClose={() => setTopicsList(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            maxWidth: 1000,
            bgcolor: "#36393F",
            border: "none",
            pt: 2,
            px: 4,
            pb: 3,
            height: "87%",
            maxHeight: "110vh",
            overflow: "auto",
            borderRadius: "8px",
            boxShadow: "0px 50px 50px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Stack width="100%">
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  style={{ color: "#fff" }}
                >
                  Keyword Suggestions
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="normal"
                  style={{ color: "#fff" }}
                >
                  Below are some keywords that we suggest could help you with
                  traffic for your blog. Pick one or add your own. Keep in mind
                  that the higher the potential traffic the more difficult it
                  may be for your blog to rank high in google search results.
                </Typography>
              </Grid>
            </Grid>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#CBCBCB",
                marginTop: "1%",
              }}
            />

            <Box
              sx={{
                maxHeight: "38vh",
                overflowY: "auto",
                marginTop: "1%",
              }}
            >
              <RadioGroup
                value={selectedKeyword}
                onChange={(e) => handleKeywordSelect(e.target.value)}
              >
                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                  {keywords && keywords.length > 0 ? (
                    <Table sx={{ width: "100%", padding: "1%" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#fff",
                              borderBottom: "1px solid #CBCBCB",
                              background: "#4BA5EB",
                            }}
                          >
                            Select
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#fff",
                              borderBottom: "1px solid #CBCBCB",
                              background: "#4BA5EB",
                            }}
                          >
                            Keyword
                          </TableCell>
                          {/* <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Potential Traffic</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {keywords.map((keyword: any, index: any) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": { bgcolor: "#0168B5", color: "#fff" },
                              bgcolor:
                                selectedKeyword === keyword.keyword
                                  ? "#0168B5"
                                  : "transparent",
                            }}
                          >
                            <TableCell
                              sx={{ borderBottom: "1px solid #CBCBCB" }}
                            >
                              <Radio
                                checked={selectedKeyword === keyword.keyword}
                                value={keyword.keyword}
                                onChange={() =>
                                  handleKeywordSelect(keyword.keyword)
                                }
                                sx={{
                                  color: "#CBCBCB",
                                  "&.Mui-checked": { color: "#4BA5EB" },
                                }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                color:
                                  selectedKeyword === keyword.keyword
                                    ? "#fff"
                                    : "#CBCBCB",
                                borderBottom: "1px solid #CBCBCB",
                              }}
                            >
                              {keyword.keyword}
                            </TableCell>
                            {/* <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.potentical_traffic}
                                                        </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <div className="alert alert-info" role="alert">
                      Keyword search failed, Please try again.
                    </div>
                  )}
                </Grid>
              </RadioGroup>
            </Box>
            <Divider
              style={{
                height: "2px",
                backgroundColor: "#CBCBCB",
                marginTop: "1%",
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ color: "#fff", textAlign: "center" }}
            >
              Or
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              // label="Selected Topic"
              value={selectedKeyword}
              onChange={(e) => setSelectedKeyword(e.target.value)}
              // InputProps={{ readOnly: true }}
              sx={{ mt: 3, bgcolor: "#35353C", borderRadius: "5px" }}
              placeholder="Input your keyword here"
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={() =>
                  handleTopicConfirmation(selectedTopic, 10, campaignId)
                }
                sx={{ color: "#fff" }}
              >
                {isKeywordLoader ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Retry"
                )}
              </Button>
              <Button
                variant="contained"
                // color="primary"
                disabled={!selectedKeyword}
                sx={{ color: "#fff" }}
                onClick={() =>
                  handleGetPageforCampaign(
                    user_email,
                    campaignId,
                    selectedTopic,
                    selectedKeyword,
                  )
                }
              >
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      {/* Delete Course Confirmation Modal */}
      <Modal
        open={deleteCourseModal}
        onClose={() => setDeleteCourseModal(false)}
        aria-labelledby="delete-course-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '380px',
          bgcolor: '#1a1a2e',
          borderRadius: '12px',
          boxShadow: '0px 8px 32px rgba(0,0,0,0.5)',
          p: 4,
          '&:focus': { outline: 'none' },
          textAlign: 'center',
        }}>
          <InfoIcon sx={{ color: '#ffcc00', fontSize: 40, mb: 1 }} />
          <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1, fontSize: '16px' }}>
            Are you sure you want to delete this course?
          </Typography>
          <Typography sx={{ color: '#aaa', fontSize: '13px', mb: 3 }}>
            This action cannot be undone.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" sx={{ background: '#ff4444', textTransform: 'none', fontWeight: 600 }}
              onClick={() => deleteCourseId && handleDeleteCourse(deleteCourseId)}>
              Yes, Delete
            </Button>
            <Button variant="outlined" sx={{ color: '#aaa', borderColor: '#555', textTransform: 'none' }}
              onClick={() => setDeleteCourseModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default Visitcourse;